import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i3 from '@ngrx/store';
import { createAction, props, createFeatureSelector, createSelector, select, createReducer, on, StoreModule } from '@ngrx/store';
import { restoreScrollPosition, sendEvent } from '@upr-web-primer/app-utils';
import { get, set, isArray, find, merge, unset } from 'lodash-es';
import { BehaviorSubject, Subscription, from, firstValueFrom, fromEvent, of, forkJoin, combineLatest, filter as filter$1, concatMap as concatMap$1, withLatestFrom as withLatestFrom$1, map as map$1, switchMap as switchMap$1 } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import * as i4 from '@angular/router';
import * as i1 from '@upr-web-primer/dal';
import * as i5 from '@upr-web-primer/digital-data';
import * as i7 from '@upr-web-primer/gds-common-utility';
import * as i2 from '@upr-web-primer/locale';
import * as i9 from '@upr-web-primer/page-labels';
import * as i6 from '@upr-web-primer/tcm-service';
import * as i8 from '@upr-web-primer/upr-mobile-service';
import { WINDOW } from '@upr-web-primer/window';
import { DateTime } from 'luxon';
import { take, map, distinctUntilChanged, filter, retry, catchError, withLatestFrom, tap, concatMap, switchMap } from 'rxjs/operators';
import * as i1$1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i4$1 from '@upr-web-primer/spinner';
const splitByOutterChar = (str, splitter, ignoredCharStart, ignoredCharEnd) => {
  const result = [];
  let currentWord = '';
  let insideIgnoredChar = false;
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (char === ignoredCharStart || char === ignoredCharEnd) {
      insideIgnoredChar = !insideIgnoredChar;
      currentWord += char;
    } else if (!insideIgnoredChar && char === splitter && currentWord.length > 0) {
      result.push(currentWord);
      currentWord = '';
    } else {
      currentWord += char;
    }
  }
  if (currentWord.length > 0) {
    result.push(currentWord);
  }
  return result;
};
const splitBeforeChar = (str, splitter, ignoredCharStart) => {
  const result = [];
  let currentWord = '';
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (char === ignoredCharStart) {
      currentWord += str.substring(i);
      break;
    } else if (char === splitter && currentWord.length > 0) {
      result.push(currentWord);
      currentWord = '';
    } else {
      currentWord += char;
    }
  }
  if (currentWord.length > 0) {
    result.push(currentWord);
  }
  return result;
};
const splitByCondition = str => {
  const result = [];
  let currentCondition = [''];
  let startedCondition = false;
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (char === '=') {
      currentCondition[currentCondition.length - 1] += '=';
      if (startedCondition) {
        const newCondition = currentCondition.pop();
        result.push(currentCondition.join(''));
        currentCondition = [newCondition.substring(1)];
      }
      startedCondition = true;
    } else if (char === ',') {
      currentCondition.push(char);
    } else {
      currentCondition[currentCondition.length - 1] += char;
    }
  }
  if (currentCondition.length > 0) {
    result.push(currentCondition.join(''));
  }
  return result;
};
var GdsFilterActionTypes;
(function (GdsFilterActionTypes) {
  GdsFilterActionTypes["FILTER_LIST"] = "filter-list";
  GdsFilterActionTypes["INTERACTIVE_MAP"] = "interactive-map";
})(GdsFilterActionTypes || (GdsFilterActionTypes = {}));
var GdsFilterComponentTypes;
(function (GdsFilterComponentTypes) {
  GdsFilterComponentTypes["SELECTION_CHIPS"] = "selectionChip";
  GdsFilterComponentTypes["CHECKBOXES"] = "checkbox";
  GdsFilterComponentTypes["DROPDOWN"] = "dropdown";
  GdsFilterComponentTypes["TOGGLE"] = "toggle";
})(GdsFilterComponentTypes || (GdsFilterComponentTypes = {}));
var GdsFilterListTileViewType;
(function (GdsFilterListTileViewType) {
  GdsFilterListTileViewType["GRID_VIEW"] = "grid-view";
  GdsFilterListTileViewType["LIST_VIEW"] = "list-view";
  GdsFilterListTileViewType["MAP_VIEW"] = "map-view";
})(GdsFilterListTileViewType || (GdsFilterListTileViewType = {}));
const LoadConfig = createAction('[Filter List] Load Config', props());
const DefaultConfigSuccess = createAction('[Filter List] Load Default Config Success', props());
const DefaultConfigFailure = createAction('[Filter List] Load Default Config Failure', props());
const InitQueryParams = createAction('[Filter List] Get Query Param Data', props());
const SetFilterElement = createAction('[Filter List] Set Filter Element AUI', props());
const LoadContentLabels = createAction('[Filter List] Load Content Labels', props());
const LoadContentLabelsSuccess = createAction('[Filter List] Load Content Labels Success', props());
const LoadContentLabelsFailure = createAction('[Filter List] Load Content Labels Failure', props());
const LoadFilterTileData = createAction('[Filter List] Filter Tile Data', props());
const LoadFilterTileDataSuccess = createAction('[Filter List] Filter Tile Data Success', props());
const LoadFilterTileDataFailure = createAction('[Filter List] Filter Tile Data Failure', props());
const LoadFilterTileDataWithContentLabels = createAction('[Filter List] Load Filter Tile Data with Content Labels', props());
const LoadFilterTileDataWithContentLabelsSuccess = createAction('[Filter List] Load Filter Tile Data with Content Labels Success', props());
const LoadFilterTileDataWithContentLabelsFailure = createAction('[Filter List] Load Filter Tile Data with Content Labels Failure', props());
const SetRequestedTiles = createAction('[Filter List] Set Requested Tile Amount', props());
const ChangeFilterTileView = createAction('[Filter List] Change Tile View', props());
const ChangeFilterTileViewSuccess = createAction('[Filter List] Change Tile View Success', props());
const ChangeFilterTileViewFailure = createAction('[Filter List] Change Tile View Failure', props());
const FilterTiles = createAction('[Filter List] Filter Tiles', props());
const FilterTilesSuccess = createAction('[Filter List] Filter Tiles Success', props());
const FilterTilesFailure = createAction('[Filter List] Filter Tiles Failure', props());
const LoadAllFilterGroupSources = createAction('[Filter List] Load All Filter Group Sources', props());
const LoadAllFilterGroupSourcesSuccess = createAction('[Filter List] Load All Filter Group Sources Success', props());
const LoadAllFilterGroupSourcesFailure = createAction('[Filter List] Load All Filter Group Sources Failure', props());
const SetAllFilters = createAction('[Filter List] Set All Filters', props());
const SetAppliedFilters = createAction('[Filter List] Set Filter Criteria', props());
const SetSelectedFilters = createAction('[Filter List] Set Selected Filter Criteria', props());
const SetSortData = createAction('[Filter List] Set Sort Data', props());
const SortFilterTilesEmpty = createAction('[Filter List] No Tiles To Sort');
const SortFilterTiles = createAction('[Filter List] Sort Filtered Tiles', props());
const filtersFeatureKey = 'gds-filter-list';
const getFiltersFeatureState = createFeatureSelector(filtersFeatureKey);
const getConfig = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId], {}));
const getFiltersParamName = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'filtersParamName'], ''));
const getAllFilters = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'allFilters'], []));
const getAllLinkedFilters = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'allLinkedFilters'], []));
const getAppliedFilters = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'appliedFilters'], []));
const getSelectedAppliedFilters = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'selectedFilters'], []));
const getNewAppliedFilters = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'newAppliedFilters'], []));
const getOverrideConfig = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'overrideConfig'], []));
const getFilterGroups = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'filterGroups'], []));
const getFilterGroupsConfig = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'filterConfig', 'filterGroups'], {}));
const getFilterTileConfig = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'filterConfig', 'filterTileData'], {}));
const getFilterTileData = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'filterTileData'], {}));
const filterListElement = contentId => createSelector(getFiltersFeatureState, state => get(state, [contentId, 'element'], {}));
const getApiCache = createSelector(getFiltersFeatureState, state => get(state, 'apiCache', {}));
const selectQueryParamsState = createSelector(getFiltersFeatureState, state => get(state, 'queryParams'));
class GdsFiltersBaseService {
  static {
    this.filterBuilderContentIds = {};
  }
  constructor(appDefaults, appRegExs, window, document, dal, localeService, store, router, route, renderer, digitalData, appDataLayer, tridion, utilities, mobileService, pageLabelsResolver) {
    this.appDefaults = appDefaults;
    this.appRegExs = appRegExs;
    this.window = window;
    this.document = document;
    this.dal = dal;
    this.localeService = localeService;
    this.store = store;
    this.router = router;
    this.route = route;
    this.renderer = renderer;
    this.digitalData = digitalData;
    this.appDataLayer = appDataLayer;
    this.tridion = tridion;
    this.utilities = utilities;
    this.mobileService = mobileService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.appliedFilters = [];
    this.queryParam$ = new BehaviorSubject(null);
    this.selectedFilters = [];
    this.overrideConfig = false;
    this.subscriptions = new Subscription();
    this.filterListView = false;
    this.initFilterData = [];
    this.dynamicLabels = {};
    this.msPlacesContainers = {};
    this.msPlacesContainerIds = {};
    this.msPlacesThemes = {};
    this.cachedHashLabels = {};
    this.HASHCODE_REGEX = get(this.appRegExs, 'HASHCODE_REGEX', new RegExp('#?#([^#/s]+)#?#', 'g'));
    this.renderer2 = this.renderer.createRenderer(null, null);
    this.subscriptions.add(this.pageLabelsResolver.$pageLabels.subscribe(pageLabels => {
      this.pageLabels = pageLabels;
    }));
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getQueryParams(filtersParamName, allFilters) {
    return this.route.queryParams.pipe(take(1), map(params => {
      if (params && params[filtersParamName] != null) {
        // Ensure the decoded filters is an actual array.
        try {
          return {
            queryParams: this.createFiltersFromQueryParams(params[filtersParamName], allFilters),
            overrideConfig: true
          };
        } catch (e) {
          return {
            queryParams: [],
            overrideConfig: false
          };
        }
      }
      return {
        queryParams: [],
        overrideConfig: false
      };
    }));
  }
  /**
   * The function stores all paths and original values of dynamic labels being used.
   * @param {any} data - the data being mutated.
   * @param {string} path - the path of the data being set.
   * @param {string} val - the value being set.
   */
  hashSet(data, path, val) {
    if (val && val.toString().match(this.HASHCODE_REGEX)) {
      this.dynamicLabels[path] = val;
    }
    set(data, path, val);
  }
  /**
   * The function updates dynamic labels within filter list.
   * @param {any} data - data being updated.
   * @param {DynamicValules} dynamicValues - the values being used to replace hash code texts within labels
   */
  updateDynamicLabels(data, dynamicValues) {
    // Allowing for case insensitive hash codes
    const values = {};
    Object.entries(dynamicValues).forEach(([key, val]) => values[key.toLowerCase()] = val);
    Object.entries(this.dynamicLabels).forEach(([path, label]) => {
      const dynamicLabel = label.replace(this.HASHCODE_REGEX, (_match, key) => {
        const k = key.toLowerCase();
        return typeof values[k] === 'number' && values[k] !== -1 ? values[k] : '';
      });
      set(data, path, dynamicLabel);
    });
  }
  /** replaces children of "filterListEl" with "configured Elements on err" */
  displayErrorMessage(aui) {
    this.filterListEl = this.document.querySelector(`[data-aui="${aui}"]`);
    if (!this.filterListEl) return;
    const flData = this.getComponentData();
    const configErrorElement = this.noResultsComponents(flData?.errorDetail, 'gds-filter-config-failed');
    this.filterListEl.replaceChildren(configErrorElement);
    this.filterListEl.data = '{}';
  }
  /** @components to load on filter list page when user filter's out */
  noResultsComponents(components, selector) {
    const groupedElements = this.renderer2.createElement('div');
    groupedElements.setAttribute('class', selector);
    const articleData = get(components, 'noMatchContent', '');
    const imageData = get(components, 'noMatchImage', '');
    const articleComponents = [{
      data: articleData,
      tag: 'gds-article-detail',
      meta: {
        type: 'center',
        theme: this.filterListEl.theme,
        role: 'alert'
      }
    }, {
      data: {},
      tag: 'gds-spacer',
      meta: {
        classes: 'spacer-100'
      }
    }];
    if (imageData) {
      articleComponents.unshift({
        data: imageData,
        tag: 'gds-picture',
        meta: {
          center: true
        }
      }, {
        data: {},
        tag: 'gds-spacer',
        meta: {
          classes: 'spacer-70'
        }
      });
    }
    articleComponents.unshift({
      data: {},
      tag: 'gds-spacer',
      meta: {
        classes: 'spacer-100'
      }
    });
    articleComponents.forEach(dataItem => {
      const element = this.renderer2.createElement(dataItem.tag);
      element.setAttribute('data', JSON.stringify(dataItem.data));
      if (dataItem.meta) {
        for (const key in dataItem.meta) {
          element.setAttribute(key, dataItem.meta[key]);
        }
      }
      groupedElements.appendChild(element);
    });
    return groupedElements;
  }
  /**
   * change filter query parameter name
   * @param name
   */
  setFilterParamName(name) {
    this.FILTERS_PARAM_NAME = name;
  }
  /**
   * Temporarily updates sidebar data upon filter selection/deselection.
   * @param filter
   */
  filterChangedHandler(filter) {
    const customKey = get(filter, 'key');
    if (this.isSidebarOpen && !!filter) {
      const fid = this.selectedFilters.some(f => f.groupKey === filter.groupKey && f.key === customKey);
      if (filter.value && !fid && !customKey.includes('#placeholder#')) {
        this.selectedFilters = [...this.selectedFilters, {
          key: filter.key,
          label: filter.label,
          value: filter.value,
          slot: filter.slot,
          parentKey: filter.parentKey,
          groupKey: filter.groupKey,
          filterMapping: filter.filterMapping
        }];
        this.logDdlEvents('New Filter Selected', 'Button', `${customKey} filter selected`);
      } else if (!filter.value) {
        this.removeFilterFromFilterCriteria(filter);
        this.logDdlEvents('Filter Removed', 'Button', `${customKey} filter removed`);
      }
      this.setSidebarData(this.mergeFilterData(filter));
    }
  }
  deleteFilterHandler(filter) {
    if (!!filter) {
      filter.value = false;
      let filterToReset = filter;
      // Get primary filter with related secondary filters and remove them from search criteria
      if (filter.parentKey === '') {
        const sidebarData = this.getSidebarData();
        (sidebarData.sections[filter.slot === 'primary' ? 0 : 2] || []).every(section => {
          if (section.type === GdsFilterComponentTypes.SELECTION_CHIPS) {
            const item = section.data.items.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
            if (item) {
              filterToReset = item;
              filterToReset.isActive = false;
              return false;
            }
          } else if (section.type === GdsFilterComponentTypes.CHECKBOXES) {
            const checkbox = section.data.checkboxes.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
            if (checkbox) {
              filterToReset = checkbox;
              filterToReset.checked = null;
              return false;
            }
          } else if (section.type === GdsFilterComponentTypes.DROPDOWN) {
            const option = section.data.options.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
            if (option) {
              filterToReset = option;
              return false;
            }
          } else if (section.type === GdsFilterComponentTypes.TOGGLE && filter.key === section.data.customEventDetail.key && filter.groupKey === section.data.customEventDetail.groupKey) {
            filterToReset = filter;
            filterToReset.value = false;
            return false;
          }
          return true;
        });
      }
      this.selectedFilters = [...this.appliedFilters];
      this.removeFilterFromFilterCriteria(filterToReset);
      this.appliedFilters = [...this.selectedFilters];
      const sidebarData = this.mergeFilterData(filter, true);
      this.setInStore(this.filterBuilderContentID);
      this.logDdlEvents('Delete Applied Filter', 'Button', `Deleted ${filter.key} applied filter`);
      this.dispatchAction(FilterTiles({
        contentId: this.filterBuilderContentID,
        actionType: this.ACTION_TYPE,
        filterGroups: sidebarData.sections
      }));
    }
  }
  toggleSidebar(state) {
    if (this.filterListEl) {
      this.isSidebarOpen = state;
      this.filterListEl.sidebar = state;
    }
  }
  clearFilters() {
    this.appliedFilters = [];
    this.selectedFilters = [];
    const sidebarData = this.getSidebarData();
    sidebarData.sections[0] = JSON.parse(this.initFilterData[0]);
    if (sidebarData.sections[1]) {
      sidebarData.sections[1] = [];
    }
    if (sidebarData.sections[2]) {
      sidebarData.sections[2] = JSON.parse(this.initFilterData[2]);
    }
    this.setInStore(this.filterBuilderContentID);
    this.dispatchAction(FilterTiles({
      contentId: this.filterBuilderContentID,
      actionType: this.ACTION_TYPE,
      filterGroups: sidebarData.sections
    }));
  }
  /* Get All keys for the filter types and remove from search criteria
   * Primary (and its Secondary children)
   * Secondary (if the filter remove is a secondary)
   * General
   * */
  removeFilterFromFilterCriteria(filter) {
    const filterObj = filter.customEventDetail || filter;
    const keysToBeRemoved = filterObj.linkedFilters ? filterObj.linkedFilters.reduce((acc, secFilter) => {
      if (secFilter.type === GdsFilterComponentTypes.SELECTION_CHIPS) {
        acc.push(...secFilter.data.items.map(f => f.customEventDetail.key));
      } else if (secFilter.type === GdsFilterComponentTypes.CHECKBOXES) {
        acc.push(...secFilter.data.checkboxes.map(f => f.customEventDetail.key));
      } else if (secFilter.type === GdsFilterComponentTypes.DROPDOWN) {
        acc.push(...secFilter.data.options.map(f => f.customEventDetail.key));
      } else if (secFilter.type === GdsFilterComponentTypes.TOGGLE) {
        acc.push(secFilter.data.customEventDetail.key);
      }
      return acc;
    }, [filterObj.key]) : [filterObj.key];
    this.selectedFilters = this.selectedFilters.filter(f => f.groupKey !== filterObj.groupKey || !keysToBeRemoved.includes(f.key));
  }
  /**
   * Method used to store component data for filter list sidebar cleared state.
   *
   * @param sidebarData
   * @param allLinkedFilters
   */
  setClearedFiltersState(sidebarData, allLinkedFilters) {
    const data = [sidebarData.sections[0] || [], allLinkedFilters, sidebarData.sections[2] || []].map(section => {
      return section.map(filter => {
        if (filter.type === GdsFilterComponentTypes.SELECTION_CHIPS) {
          return {
            ...filter,
            data: {
              ...filter.data,
              items: filter.data.items.map(f => ({
                ...f,
                isActive: false
              }))
            }
          };
        } else if (filter.type === GdsFilterComponentTypes.CHECKBOXES) {
          return {
            ...filter,
            data: {
              ...filter.data,
              checkboxes: filter.data.checkboxes.map(f => ({
                ...f,
                checked: null
              }))
            }
          };
        } else if (filter.type === GdsFilterComponentTypes.TOGGLE) {
          return {
            ...filter,
            data: {
              ...filter.data,
              initialToggle: false
            }
          };
        } else if (filter.type === GdsFilterComponentTypes.DROPDOWN) {
          return {
            ...filter,
            data: {
              ...filter.data,
              options: filter.data.options.map(f => ({
                ...f,
                isSelected: f.value === 'placeholder'
              })),
              default: 'placeholder'
            }
          };
        }
      });
    });
    this.initFilterData = [JSON.stringify(data[0]), JSON.stringify(data[1]), JSON.stringify(data[2])];
  }
  // Merge current filter data to synchronize FilterList data with sub components state.
  mergeFilterData(filter, deleted) {
    const sidebarData = this.getSidebarData();
    const isSecondaryFilter = !!filter.parentKey;
    let index = 0;
    if (isSecondaryFilter) {
      index = 1;
    } else if (filter.slot !== 'primary') {
      index = 2;
    }
    (sidebarData.sections[index] || []).every(section => {
      if (section.groupKey !== filter.groupKey || section.parentKey !== filter.parentKey) {
        return true;
      }
      if (section.type === GdsFilterComponentTypes.SELECTION_CHIPS) {
        const item = section.data.items.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
        if (item) {
          item.isActive = filter.value;
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.CHECKBOXES) {
        const checkbox = section.data.checkboxes.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
        if (checkbox) {
          checkbox.checked = filter.value ? true : null;
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.DROPDOWN) {
        const option = section.data.options.find(f => filter.groupKey === f.customEventDetail.groupKey && filter.key === f.customEventDetail.key);
        if (option) {
          option.isSelected = filter.value;
          if (deleted) {
            section.data.default = 'placeholder';
            this.setDropdownFilterValue(filter, 'placeholder');
            this.updateRangeDropdowns({
              ...option,
              value: 'placeholder'
            }, sidebarData.sections[index], section.data.type);
          }
          if (filter.value) {
            section.data.default = option.value;
            this.updateRangeDropdowns(option, sidebarData.sections[index], section.data.type);
          }
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.TOGGLE && filter.key === section.data.customEventDetail.key) {
        section.data.initialToggle = filter.value;
        return false;
      }
      return true;
    });
    return this.filterSecondaryFilters(sidebarData);
  }
  /** access filter's to adjust as per button target */
  accessFilters(btnData) {
    const target = btnData.target;
    if (target === 'open-filter') {
      this.selectedFilters = this.appliedFilters;
      this.prevSidebarData = this.getComponentData()?.sidebar;
      this.toggleSidebar(true);
    } else {
      this.clearFilters();
    }
  }
  /** Filter out secondary filters where the related primary filter value is set to false */
  filterSecondaryFilters(sidebarData) {
    if (!this.initFilterData) {
      return sidebarData;
    }
    const filterGroups = get(sidebarData, 'sections');
    const defaultSecondaryFilters = JSON.parse(this.initFilterData[1]);
    if (defaultSecondaryFilters && defaultSecondaryFilters.length > 1) {
      const selectedPrimaryFiltersKeys = this.selectedFilters.reduce((acc, f) => {
        if (f.parentKey === '') {
          acc.push(f.key);
        }
        return acc;
      }, []);
      // We should not overrite the current secondary filters with default values
      const currentSelectedSecondaryFilters = (filterGroups[1] || []).filter(filter => selectedPrimaryFiltersKeys.includes(filter.parentKey));
      // Only show secondary filters where primary filter is selected.
      // Place valid secondary filters in the correct order based on the primary filters ordering
      const validSecondaryFilters = defaultSecondaryFilters.reduce((acc, filter) => {
        if (selectedPrimaryFiltersKeys.includes(filter.parentKey)) {
          const indx = currentSelectedSecondaryFilters.findIndex(f => f.parentKey === filter.parentKey);
          if (indx > -1) {
            acc.push(currentSelectedSecondaryFilters[indx]);
            currentSelectedSecondaryFilters.splice(indx, 1);
          } else {
            acc.push(filter);
            if (filter.type === GdsFilterComponentTypes.DROPDOWN) {
              filter.data.default = 'placeholder';
              this.setDropdownFilterValue(get(filter, 'data.options[0].customEventDetail'), 'placeholder');
            }
          }
        }
        return acc;
      }, []);
      set(sidebarData, 'sections', [filterGroups[0], [...currentSelectedSecondaryFilters, ...validSecondaryFilters], filterGroups[2]]);
    }
    return sidebarData;
  }
  createFiltersFromQueryParams(filters, allFilters) {
    const filterKeys = decodeURIComponent(filters).split(',');
    const appliedFilters = [];
    filterKeys.forEach((combinedKey, index) => {
      const keys = combinedKey.split(this.KEY_SEPARATOR);
      const groupKey = get(keys, 0, '');
      const filterGroup = get(allFilters, groupKey);
      const hasFilters = Object.keys(allFilters).length > 0;
      const isDuplicate = filterKeys.findIndex(k => k === combinedKey) !== index;
      let parentKey = '';
      let key = '';
      if (isDuplicate || hasFilters && !filterGroup) {
        return;
      } else if (keys.length == 3) {
        parentKey = get(keys, 1, '');
        const childKey = get(keys, 2, '');
        key = `${parentKey}${this.KEY_SEPARATOR}${childKey}`;
      } else {
        key = get(keys, 1, '');
      }
      appliedFilters.push({
        groupKey,
        parentKey,
        key
      });
    });
    return appliedFilters;
  }
  createQueryParamsFromFilters(appliedFilters) {
    if (appliedFilters.length === 0) {
      return this.KEY_SEPARATOR;
    }
    return appliedFilters.filter(filter => !filter.key.includes('#placeholder#')).map(filter => `${filter.groupKey}${this.KEY_SEPARATOR}${filter.key}`).join(',');
  }
  cleanFilterCriteria(contentId, appliedFilters, allFilters) {
    const cleanCriteria = appliedFilters.reduce((criteria, curr) => {
      const filter = get(allFilters, [curr.groupKey, 'filters', curr.key]);
      if (filter && !curr.key.includes('#placeholder#')) {
        criteria.push({
          ...curr,
          ...filter
        });
      }
      return criteria;
    }, []);
    this.store.dispatch(SetAppliedFilters({
      contentId,
      appliedFilters: cleanCriteria,
      actionType: this.ACTION_TYPE
    }));
  }
  getComponentData(prop) {
    const attr = prop || 'data';
    const flData = this.filterListEl?.getAttribute(attr) ?? this.filterListEl[attr];
    return typeof flData === 'string' ? JSON.parse(flData) : flData;
  }
  getSidebarData() {
    const elData = this.getComponentData(this.SIDEBAR_PROP_PATH);
    return this.SIDEBAR_DATA_PATH ? get(elData, this.SIDEBAR_DATA_PATH, '') : elData;
  }
  setSidebarData(data) {
    const elData = this.getComponentData(this.SIDEBAR_PROP_PATH);
    let updatedData = data;
    if (this.SIDEBAR_DATA_PATH) {
      updatedData = {
        ...elData,
        [this.SIDEBAR_DATA_PATH]: data
      };
    }
    this.filterListEl[this.SIDEBAR_PROP_PATH] = JSON.stringify(updatedData);
  }
  /**
   * This function sets the query parameters in the store.
   */
  setInStore(contentId) {
    this.dispatchAction(SetAppliedFilters({
      contentId,
      appliedFilters: this.appliedFilters,
      actionType: this.ACTION_TYPE
    }));
  }
  setQueryParams(appliedFilters, filtersParamName) {
    if (!filtersParamName) return;
    const doesParamsExist = this.createQueryParamsFromFilters(appliedFilters) || '';
    const params = {
      [filtersParamName]: doesParamsExist
    };
    if (doesParamsExist) {
      restoreScrollPosition(() => {
        return this.router.navigate([], {
          relativeTo: this.route,
          queryParams: params,
          queryParamsHandling: 'merge'
        });
      });
    }
    const storeParams = this.store.pipe(select(selectQueryParamsState), distinctUntilChanged());
    this.subscriptions.add(storeParams.subscribe(data => {
      this.queryParam$.next(data);
    }));
  }
  updateQueryParams(appliedFilters, filtersParamName) {
    if (!filtersParamName) return;
    const doesParamsExist = this.createQueryParamsFromFilters(appliedFilters) || '';
    const params = {
      [filtersParamName]: doesParamsExist
    };
    if (doesParamsExist) {
      return from(this.router.navigate([], {
        queryParams: params,
        queryParamsHandling: 'merge'
      }));
    }
    return from(Promise.resolve(false));
  }
  async getCache(contentId, defaultSortReq) {
    const data = await firstValueFrom(this.store.pipe(select(getConfig(contentId))));
    const cachedConfig = get(data, 'filterConfig', null);
    const cachedContentLabels = get(data, 'contentLabels', null);
    const cachedFilterGroups = get(data, 'filterGroups', null);
    const cachedFilterTileData = get(data, 'filterTileData', null);
    const cachedRequestedTiles = get(cachedFilterTileData, 'requestedTiles', null);
    const cachedSortVal = get(cachedFilterTileData, 'sortData.value', null);
    const cachedAppliedFilters = get(data, 'appliedFilters');
    const cachedFiltersParamName = get(data, 'filtersParamName');
    if (!this.filterListEl.dataset?.aui) {
      await firstValueFrom(fromEvent(this.filterListEl, 'gdsComponentLoaded').pipe(filter(e => e.target === this.filterListEl)));
    }
    this.dispatchAction(SetFilterElement({
      contentId,
      element: this.filterListEl.dataset?.aui
    }));
    if (!cachedAppliedFilters || !cachedFiltersParamName) {
      this.dispatchAction(InitQueryParams({
        contentId,
        actionType: this.ACTION_TYPE,
        filtersParamName: this.FILTERS_PARAM_NAME
      }));
    } else {
      this.setQueryParams(cachedAppliedFilters, cachedFiltersParamName);
    }
    if (!cachedConfig) {
      const defaultSort = defaultSortReq ? this.createSortData(defaultSortReq) : undefined;
      this.dispatchAction(LoadConfig({
        contentId,
        defaultSort,
        defaultDisplay: this.defaultTileDisplay,
        actionType: this.ACTION_TYPE,
        element: this.filterListEl.dataset?.aui,
        filtersParamName: this.FILTERS_PARAM_NAME
      }));
      return;
    }
    this.dispatchAction(SetRequestedTiles({
      contentId: this.filterBuilderContentID,
      requestedTiles: cachedRequestedTiles || this.defaultTileDisplay,
      actionType: this.ACTION_TYPE
    }));
    if (cachedSortVal) {
      const flData = this.getComponentData();
      set(flData, 'controls.defaultSort', cachedSortVal);
      this.filterListEl.data = JSON.stringify(flData);
    }
    if (!cachedFilterTileData && !cachedContentLabels) {
      this.dispatchAction(LoadFilterTileDataWithContentLabels({
        config: cachedConfig,
        contentId,
        actionType: this.ACTION_TYPE
      }));
      return;
    }
    if (!cachedFilterTileData) {
      this.dispatchAction(LoadFilterTileData({
        config: cachedConfig,
        contentId,
        actionType: this.ACTION_TYPE
      }));
      return;
    } else if (!cachedContentLabels) {
      this.dispatchAction(LoadContentLabels({
        config: cachedConfig,
        contentId,
        actionType: this.ACTION_TYPE
      }));
      return;
    } else if (!cachedFilterGroups) {
      this.dispatchAction(LoadAllFilterGroupSources({
        config: cachedConfig,
        contentLabels: cachedContentLabels,
        contentId,
        actionType: this.ACTION_TYPE
      }));
      return;
    }
  }
  request(url) {
    const locale = this.localeService.getFromStorage();
    const language = locale?.language;
    const country = locale?.country?.toUpperCase();
    const httpOptions = new HttpHeaders({
      'Accept-Language': `${language}-${country}` + (language === 'es' ? ',en-US' : ''),
      'X-Channel-Type': 'Web'
    });
    const isAbsoluteUrl = url.match(/^https?:\/\//);
    const gatewayUrl = isAbsoluteUrl ? url : '';
    const relativeUrl = isAbsoluteUrl ? '' : url;
    const lowerCaseUrl = url.toLowerCase();
    if (lowerCaseUrl.startsWith('{tridion-data}')) {
      const tridionUrl = url.replace('{tridion-data}', `${this.tridion.tridionEnvConfig.publication}/${language}/${country}`);
      return from(this.tridion.request(tridionUrl));
    }
    if (lowerCaseUrl.startsWith('{mobile-service}')) {
      const path = url.replace('{mobile-service}', '');
      return this.mobileService.fetchData(path);
    }
    return from(this.dal.httpRequest(relativeUrl, 'GET', {}, httpOptions, undefined, undefined, undefined, gatewayUrl)).pipe(distinctUntilChanged(), retry(2), filter(Boolean), catchError(() => of(null)));
  }
  getFilterBuilderConfig(contentId, filtersParamName) {
    if (!contentId) return of(null);
    return from(this.tridion.requestContentById(contentId.replace(`_${filtersParamName}`, ''))).pipe(map(config => isArray(config) ? get(config, '[0]', null) : config));
  }
  getContentLabels(contentLabelsUrl, currApiCache) {
    if (!contentLabelsUrl) return of(null);
    const cachedData = get(currApiCache, [contentLabelsUrl], null);
    const request$ = cachedData ? of(cachedData) : this.request(contentLabelsUrl);
    return request$.pipe(map(data => {
      if (data) {
        this.contentLabels = get(data, 'elements', null);
        return {
          contentLabels: this.contentLabels,
          apiCache: {
            [contentLabelsUrl]: data
          }
        };
      }
      return null;
    }));
  }
  getFilterTileData(filterTileConfig, filterGroups, currApiCache, tileView) {
    const filterTileSource = get(filterTileConfig, 'filterDataUrl', '');
    if (!filterTileSource) return of(null);
    const resultPath = get(filterTileConfig, 'resultsPath', '');
    const mappingTable = get(filterTileConfig, 'mappingTable', []);
    const mappingTableArr = isArray(mappingTable) ? mappingTable : [mappingTable];
    const view = tileView || this.defaultTileView;
    const currentMapping = find(mappingTableArr, {
      view_type: view
    }) || get(mappingTableArr, '[0]');
    const cachedData = get(currApiCache, [filterTileSource], null);
    const request$ = cachedData ? of(cachedData) : this.request(filterTileSource);
    const filterGroupData = {};
    filterGroups.forEach(group => {
      const key = get(group, 'key', '');
      const source = get(group, 'filterSource', '');
      if (key && !filterGroupData[key]) {
        const data = get(currApiCache, [source], '');
        filterGroupData[key] = {
          filter: group,
          data
        };
      }
    });
    return request$.pipe(map(data => {
      if (!data) return;
      const results = resultPath ? this.getSelector(data, resultPath, [], true) : data;
      const resultsArr = isArray(results) ? results : [results];
      const cachedPath = [filterTileSource];
      const baseResultPath = resultPath.replace(/\.?\[.*?\=.*?\]/g, '');
      if (baseResultPath) {
        cachedPath.push(baseResultPath);
      }
      return {
        filterTiles: this.parseFilterTiles(resultsArr, currentMapping, filterGroupData, cachedPath),
        apiCache: {
          [filterTileSource]: data
        }
      };
    }));
  }
  getFilterSource(filterSource, currApiCache) {
    if (!filterSource) return of(null);
    const cachedData = get(currApiCache, [filterSource], null);
    const request$ = cachedData ? of(cachedData) : this.request(filterSource);
    return request$.pipe(map(data => data ? {
      data,
      apiCache: {
        [filterSource]: data
      }
    } : null));
  }
  getFilterGroupSources(contentId, filterGroups, contentLabels, initialAppliedFilters, allFilters, overrideConfig, currApiCache) {
    const groups = this.groupDuplicateFilterSources(filterGroups);
    const updatedFilters = {
      ...allFilters
    };
    const defaultAppliedFilters = [...initialAppliedFilters];
    const allLinkedFilters = [];
    const output = Object.entries(groups).map(([url, filterGroups]) => url === 'custom' ? of({
      filterGroups
    }) : this.getFilterSource(url, currApiCache).pipe(map(({
      data,
      apiCache
    }) => data ? {
      filterGroups,
      data,
      apiCache
    } : null)));
    return forkJoin(output).pipe(map(filterSources => {
      const sections = [[], [], []];
      const dropdownSections = {
        primary: [],
        general: []
      };
      let apiCache = {};
      let prevGroupKey = '';
      filterSources.flat().forEach(filterSource => get(filterSource, 'filterGroups', []).forEach(filterGroup => {
        const newApiCache = get(filterSource, 'apiCache', null);
        const data = get(filterSource, 'data', null);
        if (apiCache && data) {
          apiCache = {
            ...apiCache,
            ...newApiCache
          };
        }
        const groupKey = get(filterGroup, 'key', '').toLowerCase();
        const dynamicFilters = this.createFilterFromSource(data, '', filterGroup);
        const dynamicFilterGroup = {
          ...filterGroup,
          filters: dynamicFilters.filter(df => !!df.key)
        };
        const filter = this.parseComponentData(groupKey, dynamicFilterGroup, prevGroupKey === groupKey, contentLabels, data, overrideConfig, initialAppliedFilters);
        const filterComponent = get(filter, 'component');
        let rangeDropdownSection;
        if (!filterComponent) {
          return;
        } else if (filterComponent.slot === 'primary') {
          sections[0].push(filterComponent);
          sections[1].push(...filterComponent.defaultLinkedFilters);
          rangeDropdownSection = dropdownSections.primary;
        } else {
          sections[2].push(filterComponent);
          rangeDropdownSection = dropdownSections.general;
        }
        const componentData = get(data, 'component', {});
        const componentType = get(componentData, 'type', '');
        const dropdownType = get(componentData, 'data.type', '');
        const defaultOption = get(componentData, 'defaultOption', null);
        if (componentType === GdsFilterComponentTypes.DROPDOWN && defaultOption && dropdownType) {
          rangeDropdownSection.push({
            option: defaultOption,
            type: dropdownType
          });
        }
        const newDefaultAppliedFilters = get(filter, 'config.defaultAppliedFilters', []);
        allLinkedFilters.push(...get(filter, 'config.allLinkedFilters', []));
        const createdFilters = get(filter, ['config', 'createdFilters', groupKey, 'filters']);
        const filterByDataMapping = get(filterComponent, 'filterByDataMapping', '');
        const currFilters = get(updatedFilters, [groupKey, 'filters'], {});
        set(updatedFilters, [groupKey, 'filters'], merge(createdFilters, currFilters));
        set(updatedFilters, [groupKey, 'filterByDataMapping'], filterByDataMapping);
        defaultAppliedFilters.push(...newDefaultAppliedFilters);
        prevGroupKey = groupKey;
      }));
      dropdownSections.primary.forEach(rangeData => {
        this.updateRangeDropdowns(rangeData.option, dropdownSections.primary, rangeData.type);
      });
      dropdownSections.general.forEach(rangeData => {
        this.updateRangeDropdowns(rangeData.option, dropdownSections.general, rangeData.type);
      });
      this.store.dispatch(SetAllFilters({
        contentId,
        allFilters: updatedFilters,
        allLinkedFilters,
        actionType: this.ACTION_TYPE
      }));
      if (!overrideConfig) {
        this.dispatchAction(SetAppliedFilters({
          contentId,
          appliedFilters: defaultAppliedFilters,
          actionType: this.ACTION_TYPE
        }));
      } else {
        this.cleanFilterCriteria(contentId, initialAppliedFilters, updatedFilters);
      }
      return {
        filterGroups: sections,
        apiCache
      };
    }));
  }
  async setSortedTiles(contentId, sortReq) {
    const sortData = this.createSortData(sortReq);
    const data = await firstValueFrom(this.store.pipe(select(getFilterTileData(contentId))));
    const prevSort = get(data, 'sortData.value', '');
    if (prevSort === sortData.value) return;
    this.dispatchAction(SetSortData({
      contentId,
      sortData,
      actionType: this.ACTION_TYPE
    }));
  }
  createSortData(sortReq) {
    const mapping = get(sortReq, 'mapping', '');
    const key = get(sortReq, 'key', '').toLowerCase();
    const order = key.indexOf('descending') > -1 ? 'desc' : 'asc';
    return {
      mapping,
      order,
      value: JSON.stringify(sortReq)
    };
  }
  getTileSort(tile, data, mapping) {
    const tileDataPath = get(tile, 'cachedPath', []);
    const tileData = get(data, tileDataPath);
    return get(tileData, mapping, '').toString().toLowerCase();
  }
  sortTiles(filterTileData, cachedData) {
    const locale = this.localeService.getFromStorage();
    const language = locale?.language;
    const collator = Intl.Collator(language, {
      numeric: true,
      ignorePunctuation: true
    });
    const sortData = get(filterTileData, 'sortData', '');
    const currTiles = get(filterTileData, 'results', []);
    const parsedValue = JSON.parse(get(sortData, 'value', '{}'));
    const sortDataKey = get(parsedValue, 'key', '').toLowerCase();
    const sortByDate = sortDataKey.includes('date');
    return sortByDate ? this.sortTilesByDate(currTiles, cachedData, sortData) : this.sortTilesByMapping(currTiles, cachedData, collator, sortData);
  }
  sortTilesByMapping(tiles, cachedData, collator, sortData) {
    return this.sortTilesBy(tiles, cachedData, sortData.mapping, collator, sortData.order, (tile, cachedData, key) => this.getTileSort(tile, cachedData, key));
  }
  sortTilesByDate(tiles, cachedData, sortData) {
    const dateFormats = ['M/d/yyyy h:mm:ss a',
    // 9/17/2024 1:00:10 AM
    'M/d/yyyy hh:mm:ss a',
    // 9/17/2024 01:00:10 AM (with leading zero in hour)
    'MM/dd/yyyy h:mm:ss a',
    // 09/17/2024 1:00:10 AM
    'MM/dd/yyyy hh:mm:ss a',
    // 09/17/2024 01:00:10 AM
    'yyyy-MM-dd HH:mm:ss' // 2024-09-17 13:00:10 (ISO 8601)
    ];
    return this.sortTilesBy(tiles, cachedData, sortData.mapping, null, sortData.order, (tile, cachedData, key) => {
      const dateStr = this.getTileSort(tile, cachedData, key);
      const dateTime = dateFormats.map(format => DateTime.fromFormat(dateStr, format)).find(date => date.isValid);
      return dateTime?.isValid ? dateTime.toMillis() : null;
    });
  }
  sortTilesBy(tiles, cachedData, sortDataMapping, collator, sortOrder, getSortValue) {
    return tiles.toSorted((tile1, tile2) => {
      const _tile1 = getSortValue(tile1, cachedData, sortDataMapping);
      const _tile2 = getSortValue(tile2, cachedData, sortDataMapping);
      if (_tile1 === _tile2) return 0;
      if (_tile1 === null) return 1;
      if (_tile2 === null) return -1;
      if (collator) {
        return sortOrder === 'asc' ? collator.compare(_tile1, _tile2) : collator.compare(_tile2, _tile1);
      } else {
        return sortOrder === 'asc' ? _tile1 - _tile2 : _tile2 - _tile1;
      }
    });
  }
  applyLinkedFilters(filters, tile) {
    if (!filters) return true;
    return Object.entries(filters).every(entry => {
      const path = entry[0];
      const filterType = entry[1].filterType;
      const keys = entry[1].keys;
      return keys.some(key => {
        const pathObject = this.getSelector(tile, path, '');
        const specialFilters = this.applyInternalLinkedFilters(tile, path, key);
        if (specialFilters) {
          return true;
        }
        if (isArray(pathObject)) {
          return pathObject.some(data => data.toString().toLowerCase() === key.toLowerCase());
        } else if (!isArray(pathObject) && [true, 'true'].includes(pathObject)) {
          return true;
        } else if (filterType === 'min') {
          const formatMinKey = key.slice(3);
          return pathObject === '' || pathObject >= formatMinKey;
        } else if (filterType === 'max') {
          const formatMaxKey = key.slice(3);
          return pathObject === '' || pathObject <= formatMaxKey;
        } else if (typeof pathObject === 'string') {
          return pathObject.toLowerCase().split(',').includes(key.toLowerCase());
        } else {
          return pathObject === key;
        }
      });
    });
  }
  /**
   * Getting all applied filters.
   *
   * @returns AppliedFilters
   */
  getAppliedFilters(appliedFilters, allFilters, allLinkedFilters) {
    const filters = {};
    const activeLinkedFilters = {};
    appliedFilters.forEach(filter => {
      const groupKey = get(filter, 'groupKey', '').toLowerCase();
      const key = get(filter, 'key', '').toLowerCase();
      if (filter.parentKey) {
        const linkedFilter = this.searchFilter(allLinkedFilters, key, groupKey);
        const mapping = get(linkedFilter, 'customEventDetail.filterMapping', '');
        const filterType = get(linkedFilter, 'customEventDetail.type', '');
        if (!mapping) return;
        const linkedFiltersPath = [groupKey, filter.parentKey, mapping, 'keys'];
        let linkedGroup = get(activeLinkedFilters, linkedFiltersPath);
        if (!linkedGroup) {
          set(activeLinkedFilters, linkedFiltersPath, []);
          linkedGroup = get(activeLinkedFilters, linkedFiltersPath);
        }
        linkedGroup.push(key.replace(`${filter.parentKey}${this.KEY_SEPARATOR}`, ''));
        set(activeLinkedFilters, [groupKey, filter.parentKey, mapping, 'filterType'], filterType);
      } else {
        const groupData = allFilters[groupKey];
        const filterByDataMapping = get(groupData, 'filterByDataMapping', '');
        if (!groupData || !filterByDataMapping) return;
        if (!filters[groupKey]) filters[groupKey] = {
          path: filterByDataMapping,
          keys: []
        };
        filters[groupKey].keys.push(filter.key.toString().toLowerCase());
      }
    });
    return {
      filters,
      activeLinkedFilters
    };
  }
  filterTiles(filterTileData, allFilters, allLinkedFilters, appliedFilters, cachedData) {
    const sortedTiles = get(filterTileData, 'sortedTiles', []);
    const isMapView = get(filterTileData, 'view', '') === GdsFilterListTileViewType.MAP_VIEW;
    const {
      filters,
      activeLinkedFilters
    } = this.getAppliedFilters(appliedFilters, allFilters, allLinkedFilters);
    if (isMapView) {
      for (const groupKey in filters) {
        const filter = filters[groupKey];
        if (filter.path === 'place.place_type.type') {
          filter.keys.push('park', 'land', 'hotel');
          break;
        }
      }
    }
    // Do the primary tile filtering here
    const filteredTiles = sortedTiles.filter(tile => {
      const tileDataPath = get(tile, 'cachedPath', []);
      const tileData = get(cachedData, tileDataPath);
      const appliedInternalFilter = this.applyInternalFilters(tileData, {
        isMapView
      });
      if (appliedInternalFilter !== null) {
        return appliedInternalFilter;
      }
      if (appliedFilters.length === 0) {
        return true;
      }
      return Object.entries(filters).every(entry => {
        const groupKey = entry[0];
        const filter = entry[1];
        // Using filterByDataMapping field from tridion to grab required result values
        const val = this.getSelector(tileData, filter.path, '');
        // Handle toggle case, else handle checkbox case
        if ([true, 'true'].includes(val)) {
          const key = get(filter, 'keys[0]', false);
          const linkedFilters = get(activeLinkedFilters, [groupKey, key]);
          return this.applyLinkedFilters(linkedFilters, tileData);
        } else if (isArray(val)) {
          return filter.keys.some(key => val.some(value => {
            if (key.split(this.COMBO_FILTER_KEY_SEPARATOR).includes(value.toString().toLowerCase())) {
              const linkedFilters = get(activeLinkedFilters, [groupKey, key]);
              return this.applyLinkedFilters(linkedFilters, tileData);
            }
            return false;
          }));
        } else {
          const key = filter.keys.find(key => key.split(this.COMBO_FILTER_KEY_SEPARATOR).includes(val.toString().toLowerCase()));
          if (key) {
            const linkedFilters = get(activeLinkedFilters, [groupKey, key]);
            return this.applyLinkedFilters(linkedFilters, tileData);
          }
          return false;
        }
      });
    });
    return filteredTiles;
  }
  parseFilterTiles(results, mappingData, filterGroupData, rawDataPath) {
    const mappings = get(mappingData, 'viewMapping', []);
    const parsedResults = results.map((rawResult, i) => {
      const parsedResult = {};
      mappings.forEach(mapping => {
        let isConditionMatch;
        if (mapping.conditions) {
          const conditionsArray = typeof mapping.conditions === 'string' ? splitByCondition(mapping.conditions) : mapping.conditions;
          isConditionMatch = Array.isArray(conditionsArray) && conditionsArray.every(condition => this.getSelector(rawResult, condition.trim(), null, false, true));
        }
        if (isConditionMatch === false) {
          return;
        }
        // split by all whitespaces not within a pair of quotes.
        const values = splitByOutterChar(mapping.value.trim(), ' ', '"', '"');
        const combinedValue = values.reduce((prev, currVal) => {
          const content = currVal.match(/^"(.+)"/);
          this.HASHCODE_REGEX.lastIndex = 0;
          const hash = this.HASHCODE_REGEX.exec(currVal);
          const hashKey = get(hash, 1, '');
          let val = '';
          if (content) {
            val = get(this.contentLabels, content[1]) || get(this.pageLabels, content[1], content[1]);
          } else if (hashKey?.toLowerCase() === 'theme') {
            const poiTheme = get(rawResult, 'place.theme');
            const landId = get(rawResult, 'place.land_id');
            const venueId = get(rawResult, 'place.venue_id');
            val = poiTheme || this.msPlacesThemes[landId] || this.msPlacesThemes[venueId];
          } else if (hashKey) {
            const group = get(filterGroupData, [hashKey], '');
            const tileKeyPath = get(group, 'filter.filterByDataMapping', '');
            const tileKey = this.getSelector(rawResult, tileKeyPath, '');
            const cachedLabel = get(this.cachedHashLabels, [hashKey, tileKey], undefined);
            if (cachedLabel === undefined) {
              val = this.getLabelFromFilterGroup(group, tileKey, tileKeyPath);
              set(this.cachedHashLabels, [hashKey, tileKey], val);
            } else {
              val = cachedLabel;
            }
          } else {
            val = this.getSelector(rawResult, currVal, '');
          }
          if (mapping.key.includes('image') && typeof val === 'string') {
            val = this.utilities.resolveImagePath(val);
          } else if (mapping.key.includes('locationEyebrow.eyebrow')) {
            const containerId = get(this.msPlacesContainerIds, val, val);
            val = get(this.msPlacesContainers, containerId, containerId);
          } else if (currVal.toLowerCase().includes('times') && Array.isArray(val)) {
            val = this.formatHours(val);
          }
          if (typeof val === 'string') {
            return prev + val;
          }
          return val ?? prev;
        }, '');
        set(parsedResult, mapping.key, combinedValue);
      });
      const cachedIndex = get(rawResult, 'cachedIndex');
      const index = cachedIndex != null ? cachedIndex : i;
      set(parsedResult, 'cachedPath', rawDataPath?.concat(index));
      return parsedResult;
    });
    return {
      view: get(mappingData, 'view_type', ''),
      cardType: get(mappingData, 'gdsComponentName', ''),
      results: parsedResults
    };
  }
  /**
   * Method used to pull label string from specified Filter Group.
   *
   * @param group - Filter group data
   * @param tileKey - Tile key used to identify each tile
   * @param tileKeyPath - Tile key path
   * @returns string
   */
  getLabelFromFilterGroup(group, tileKey, tileKeyPath) {
    if (!group) {
      return '';
    }
    const sourcePath = get(group, 'filter.sourcePath', '');
    const keyPath = get(group, 'filter.keyPath', '');
    const labelPath = get(group, 'filter.labelPath', '');
    const filterOverrides = get(group, 'filter.filters', []);
    const currOverride = filterOverrides.find(override => get(override, 'key', '').toLowerCase().split(this.COMBO_FILTER_KEY_SEPARATOR).includes(tileKey.toLowerCase()));
    if (currOverride?.label) {
      return get(this.contentLabels, [currOverride.label], currOverride.label);
    }
    const rawGroupDataArr = get(group, 'data', []);
    const groupDataArr = sourcePath ? this.getSelector(rawGroupDataArr, sourcePath, '') : rawGroupDataArr;
    if (!Array.isArray(groupDataArr)) {
      return '';
    }
    const currGroupData = groupDataArr.find(groupData => {
      const groupKey = this.getSelector(groupData, keyPath, '');
      return tileKey && tileKey === groupKey;
    });
    const groupLabel = this.getSelector(currGroupData, labelPath, '');
    return this.getLabelFromFilterGroupByType(groupLabel, tileKeyPath);
  }
  /**
   * Method used to pull formatted label from filter group label data
   *
   * @param label - Filter group label data
   * @param tileKeyPath - Path to tile's key
   * @returns string
   */
  getLabelFromFilterGroupByType(label, tileKeyPath) {
    if (typeof label === 'object' && tileKeyPath === 'store') {
      const url = get(label, 'link-url.Value', '');
      const urlLabel = get(label, 'link-text.Value', '');
      const analytics = get(label, 'analytics-title.Value', '');
      const prefix = get(label, 'label-pre-link.Value', '');
      const suffix = get(label, 'label-post-link.Value', '');
      const gdsButton = `<a href='${url}' analytics-title='${analytics}'>${urlLabel}</a> `;
      const button = url && urlLabel ? gdsButton : '';
      return [prefix, button, suffix].filter(Boolean).join('');
    }
    return label;
  }
  storeMsPlacesContainers(place) {
    const placeType = get(place, 'place.place_type.type', '');
    const landId = get(place, 'place.land_id', '');
    const id = get(place, 'place.place_id');
    const name = get(place, 'place.name');
    const theme = get(place, 'place.theme');
    if (!id || !name) return;
    if (['Land', 'Park', 'Resort', 'Hotel'].includes(placeType)) {
      this.msPlacesContainers[id] = name;
    }
    if (landId) {
      this.msPlacesContainerIds[id] = landId;
    }
    if (theme) {
      this.msPlacesThemes[id] = theme;
    }
  }
  runSelectorOperation(operator, lookupVal, itemVal) {
    switch (operator) {
      case '=':
        return lookupVal.includes(itemVal);
      case '!=':
        return !lookupVal.includes(itemVal);
      case '*=':
        return lookupVal.some(val => itemVal?.toString().includes(val));
      case '!*=':
        return !lookupVal.some(val => itemVal?.toString().includes(val));
      case '^=':
        return lookupVal.some(val => itemVal?.toString().startsWith(val));
      case '!^=':
        return !lookupVal.some(val => itemVal?.toString().startsWith(val));
      default:
        return false;
    }
  }
  /**
   * This function is used to partially mimic querySelector. Allowing for array lookups from Tridion data mapping.
   *
   * Example: "place.urls[url_type=POI_Result].url" grabs url value from the first object containing `{ url_type: "POI_Result", ... }`.
   */
  getSelector(data, path, defaultVal, appendIndex = false, isCondition = false) {
    if (!path) return data;
    const selectorRegex = isCondition ? /(.*?)([!\*\^\=]+)(.+)/ : /(.*)?\[(.*?)([!\*\^\=]+)(.+)\]/;
    const hasArraySelector = isCondition || path.match(selectorRegex);
    if ((hasArraySelector || path.includes('[:')) && data) {
      // Splitting by "." when not within square brackets.
      const paths = isCondition ? splitBeforeChar(path, '.', '=') : splitByOutterChar(path, '.', '[', ']');
      return paths.reduce((prev, curr) => {
        const selectors = curr.match(selectorRegex);
        const nestedSelectors = curr.match(/(.*)?\[:(.*)\]/);
        if (selectors && !isCondition) {
          const array = isArray(prev) ? prev : get(prev, selectors[1], prev);
          const key = selectors[2];
          const operator = selectors[3];
          const lookupVal = selectors[4].split(',');
          let cachedIndex = 0;
          return isArray(array) && array.reduce((filteredArray, item) => {
            const itemVal = get(item, key, '');
            const isMatch = this.runSelectorOperation(operator, lookupVal, itemVal);
            if (appendIndex) {
              item = Object.assign({}, item, {
                cachedIndex
              });
              cachedIndex++;
              this.storeMsPlacesContainers(item);
            }
            if (isMatch) {
              filteredArray.push(item);
            }
            return filteredArray;
          }, []);
        } else if (selectors && isCondition) {
          const key = selectors[1];
          const itemVal = get(prev, key, '');
          const operator = selectors[2];
          const lookupVal = selectors[3]?.split(',');
          const isMatch = this.runSelectorOperation(operator, lookupVal, itemVal);
          return isMatch && prev;
        } else if (nestedSelectors) {
          const array = isArray(prev) ? prev : get(prev, nestedSelectors[1], prev);
          const path = nestedSelectors[2];
          return isArray(array) && array.flatMap(item => get(item, path, ''));
        } else {
          const child = get(prev, curr);
          if (isArray(prev) && !child) {
            return get(prev, [0, curr]);
          }
          return child;
        }
      }, data) || defaultVal;
    }
    return get(data, path, defaultVal);
  }
  groupDuplicateFilterSources(filterGroups) {
    return filterGroups.reduce((acc, item) => {
      const url = item.filterSource || 'custom';
      if (!acc[url]) {
        acc[url] = [];
      }
      acc[url].push(item);
      return acc;
    }, {});
  }
  parseComponentData(groupKey, filterGroup, isCombined, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters) {
    const filterType = get(filterGroup, 'filterType', '').toLowerCase().trim().replace(/[-\s]/g, '_');
    const isHidden = [true, 'true'].includes(get(filterGroup, 'hidden', false));
    if (isHidden) return null;
    const showInAccordion = filterType.startsWith('accordion');
    switch (filterType) {
      case 'multi_selection_chips':
      case 'accordion_multi_selection_chips':
        return this.createFilterSelectionChips(groupKey, filterGroup, isCombined, contentLabels, showInAccordion, 'multi', filterSourceData, overrideConfig, initialAppliedFilters);
      case 'single_selection_chips':
      case 'accordion_single_selection_chips':
        return this.createFilterSelectionChips(groupKey, filterGroup, isCombined, contentLabels, showInAccordion, 'single', filterSourceData, overrideConfig, initialAppliedFilters);
      case 'checkbox':
      case 'accordion_checkbox':
        return this.createFilterCheckbox(groupKey, filterGroup, isCombined, contentLabels, showInAccordion, filterSourceData, overrideConfig, initialAppliedFilters);
      case 'toggle':
        return this.createToggle(groupKey, filterGroup, isCombined, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters);
      case 'dropdown':
      case 'dropdown_min':
      case 'dropdown_max':
        return this.createDropdown(groupKey, filterGroup, isCombined, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters);
      default:
        return null;
    }
  }
  parseLinkedFilters(groupKey, parentFilter, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters) {
    const parentKey = get(parentFilter, 'key', '');
    const parentSource = get(parentFilter, 'filterSource', '');
    const rawLinkedFilters = get(parentFilter, 'linkedFilters', []);
    const linkedFilters = isArray(rawLinkedFilters) ? rawLinkedFilters : [rawLinkedFilters];
    const rangeDropdowns = [];
    let prevSecondaryGroupKey = '';
    const parsedLinkedFilters = linkedFilters.map(linkedFilter => {
      const filters = filterSourceData ? this.createFilterFromSource(filterSourceData, parentSource, linkedFilter) : get(linkedFilter, 'filters', []);
      const data = this.parseComponentData(groupKey, {
        ...linkedFilter,
        filters,
        parentKey,
        secondaryGroupKey: linkedFilter.key
      }, prevSecondaryGroupKey === linkedFilter.key, contentLabels, null, overrideConfig, initialAppliedFilters);
      prevSecondaryGroupKey = linkedFilter.key;
      const componentData = get(data, 'component', {});
      const componentType = get(componentData, 'type', '');
      const dropdownType = get(componentData, 'data.type', '');
      const defaultOption = get(componentData, 'defaultOption', null);
      if (componentType === GdsFilterComponentTypes.DROPDOWN && defaultOption && dropdownType) {
        rangeDropdowns.push({
          option: defaultOption,
          type: dropdownType
        });
      }
      return data;
    }).filter(Boolean);
    rangeDropdowns.forEach(rangeData => {
      this.updateRangeDropdowns(rangeData.option, parsedLinkedFilters, rangeData.type);
    });
    return parsedLinkedFilters;
  }
  createFilterObjects(filter, keyPath, labelPath, imagePath) {
    const filters = [];
    if (typeof filter === 'object') {
      const keyData = get(filter, keyPath, '');
      const labelData = get(filter, labelPath, '');
      const labels = typeof labelData === 'string' ? labelData.split(',') : labelData;
      let image;
      if (imagePath) {
        image = this.getSelector(filter, imagePath, undefined);
      }
      if (isArray(labels)) {
        labels.forEach(label => {
          filters.push({
            key: keyPath === labelPath ? label : keyData,
            label: label,
            image
          });
        });
      }
    } else if (filter) {
      filters.push({
        key: filter,
        label: filter
      });
    }
    return filters;
  }
  createFilterFromSource(sourceData, parentPath, linkedFilter) {
    let filters = [];
    const sourcePath = get(linkedFilter, 'sourcePath', '');
    const keyPath = get(linkedFilter, 'keyPath', '');
    const labelPath = get(linkedFilter, 'labelPath', '');
    const imagePath = get(linkedFilter, 'imagePath', '');
    const filterOverrides = new Array().concat(parentPath ? get(linkedFilter, 'secondayFilterLables', []) : get(linkedFilter, 'filters', []));
    const parentData = this.getSelector(sourceData, parentPath, []);
    const parentDataArr = isArray(parentData) ? parentData : [parentData];
    parentDataArr.forEach(data => {
      const childData = this.getSelector(data, sourcePath, '');
      if (!childData) return;
      const children = isArray(childData) ? childData : [childData];
      children.forEach(data => {
        this.storeMsPlacesContainers(data);
        const newFilters = this.createFilterObjects(data, keyPath, labelPath, imagePath).filter(filter => !filters.find(f => f.key === filter.key && f.label.toLowerCase() === filter.label.toLowerCase()));
        filters = filters.concat(newFilters);
      });
    });
    const filterOverrideIndexes = filterOverrides.reduce((indexes, override, index) => {
      if (override.key) {
        indexes[override.key.toLowerCase()] = index;
        const dynamicIndex = filters.findIndex(filter => get(filter, 'key', '').toLowerCase() === override.key.toLowerCase());
        if (dynamicIndex === -1) {
          filters.push(override);
        } else {
          filters[dynamicIndex] = {
            ...override,
            label: override.label || filters[dynamicIndex].label,
            image: override.image || filters[dynamicIndex].image
          };
        }
      }
      return indexes;
    }, {});
    return filters.sort((a, b) => {
      if (!a.key) {
        return 1;
      } else if (!b.key) {
        return -1;
      }
      const aIndex = filterOverrideIndexes[a.key.toLowerCase()] ?? -1;
      const bIndex = filterOverrideIndexes[b.key.toLowerCase()] ?? -1;
      if (aIndex === bIndex) {
        return 0;
      } else if (bIndex === -1 || aIndex > -1 && aIndex < bIndex) {
        return -1;
      } else {
        return 1;
      }
    });
  }
  createToggle(groupKey, filterGroup, isCombined, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters) {
    const filterByDataMapping = get(filterGroup, 'filterByDataMapping', '');
    const filterGroupLabel = get(filterGroup, 'label', '');
    const key = this.formatFilterKey(filterGroup);
    const parentKey = get(filterGroup, 'parentKey', '').toLowerCase();
    const secondaryGroupKey = get(filterGroup, 'secondaryGroupKey', '').toLowerCase();
    const slot = get(filterGroup, 'type', '');
    const filterMapping = get(filterGroup, 'filterByDataMapping', '');
    const isDefault = 'true' === get(filterGroup, 'default', false).toString();
    let initialToggle = false;
    const defaultAppliedFilters = [];
    const createdFilters = {
      [groupKey]: {
        filterByDataMapping,
        filters: {}
      }
    };
    if (overrideConfig) {
      initialToggle = this.searchFilterCriteria(filterGroup, parentKey, groupKey, initialAppliedFilters);
    } else if (isDefault) {
      initialToggle = true;
      defaultAppliedFilters.push({
        key: parentKey ? `${parentKey}${this.KEY_SEPARATOR}${key}`.toLowerCase() : key,
        label: filterGroupLabel,
        parentKey,
        secondaryGroupKey,
        groupKey,
        slot: parentKey ? '' : slot,
        filterMapping
      });
    }
    const linkedFilters = filterGroup.linkedFilters ? this.parseLinkedFilters(groupKey, filterGroup, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters) : [];
    const linkedFilterComponents = [];
    linkedFilters.forEach(linkedFilter => {
      linkedFilterComponents.push(linkedFilter.component);
      defaultAppliedFilters.push(...linkedFilter.config.defaultAppliedFilters);
      const linkedFilterGroup = get(linkedFilter, ['config', 'createdFilters', groupKey, 'filters']);
      for (const key in linkedFilterGroup) {
        if (linkedFilterGroup.hasOwnProperty(key)) {
          createdFilters[groupKey].filters[key] = {
            label: linkedFilterGroup[key].label,
            slot: ''
          };
        }
      }
    });
    const formattedKey = parentKey ? `${parentKey}${this.KEY_SEPARATOR}${key}` : key;
    const label = get(contentLabels, [filterGroupLabel], filterGroupLabel);
    set(createdFilters, [groupKey, 'filters', formattedKey], {
      label,
      slot
    });
    return {
      component: {
        slot,
        type: GdsFilterComponentTypes.TOGGLE,
        parentKey,
        secondaryGroupKey,
        groupKey,
        data: {
          label,
          initialToggle,
          customEventDetail: {
            key: formattedKey,
            slot,
            linkedFilters: linkedFilterComponents,
            parentKey,
            secondaryGroupKey,
            groupKey,
            filterMapping
          }
        },
        defaultLinkedFilters: initialToggle ? linkedFilterComponents : [],
        filterByDataMapping,
        combined: isCombined
      },
      config: {
        defaultAppliedFilters,
        createdFilters,
        allLinkedFilters: linkedFilterComponents
      }
    };
  }
  createFilterCheckbox(groupKey, filterGroup, isCombined, contentLabels, showInAccordion, filterSourceData, overrideConfig, initialAppliedFilters) {
    const filterByDataMapping = get(filterGroup, 'filterByDataMapping', '');
    const filterGroupLabel = get(filterGroup, 'label', '');
    const filterGroupDescription = get(filterGroup, 'description', '');
    const parentKey = get(filterGroup, 'parentKey', '').toLowerCase();
    const secondaryGroupKey = get(filterGroup, 'secondaryGroupKey', '').toLowerCase();
    const slot = get(filterGroup, 'type', '');
    const rawFilters = get(filterGroup, 'filters', []);
    const filterMapping = get(filterGroup, 'filterByDataMapping', '');
    const filters = isArray(rawFilters) ? rawFilters : [rawFilters];
    const allLinkedFilters = [];
    const defaultLinkedFilters = [];
    const defaultAppliedFilters = [];
    const createdFilters = {
      [groupKey]: {
        filterByDataMapping,
        filters: {}
      }
    };
    const checkboxes = filters.filter(filter => !!filter && !['true', true].includes(get(filter, 'hidden', false))).map(filter => {
      const key = this.formatFilterKey(filter);
      const label = get(filter, 'label', '');
      const primaryLabel = get(contentLabels, [label], label);
      const isDefault = get(filterGroup, 'default', '').toString().toLowerCase().split(',').includes(key);
      let checked = null;
      if (overrideConfig) {
        checked = this.searchFilterCriteria(filter, parentKey, groupKey, initialAppliedFilters) || null;
      } else if (isDefault) {
        checked = true;
        defaultAppliedFilters.push({
          key,
          label,
          parentKey,
          secondaryGroupKey,
          groupKey,
          slot: parentKey ? '' : slot,
          filterMapping
        });
      }
      const linkedFilters = this.parseLinkedFilters(groupKey, filter, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters);
      const linkedFilterComponents = [];
      linkedFilters.forEach(linkedFilter => {
        linkedFilterComponents.push(linkedFilter.component);
        defaultAppliedFilters.push(...linkedFilter.config.defaultAppliedFilters);
        const linkedFilterGroup = get(linkedFilter, ['config', 'createdFilters', groupKey, 'filters']);
        for (const key in linkedFilterGroup) {
          if (linkedFilterGroup.hasOwnProperty(key)) {
            createdFilters[groupKey].filters[key] = {
              label: linkedFilterGroup[key].label,
              slot: ''
            };
          }
        }
      });
      allLinkedFilters.push(...linkedFilterComponents);
      if (checked) {
        defaultLinkedFilters.push(...linkedFilterComponents);
      }
      const formattedKey = parentKey ? `${parentKey}${this.KEY_SEPARATOR}${key}` : key;
      set(createdFilters, [groupKey, 'filters', formattedKey], {
        label: primaryLabel,
        slot
      });
      return {
        primaryLabel,
        checked,
        customEventDetail: {
          key: formattedKey,
          slot,
          linkedFilters: linkedFilterComponents,
          parentKey,
          secondaryGroupKey,
          groupKey,
          filterMapping
        }
      };
    });
    return checkboxes.length > 0 ? {
      component: {
        type: GdsFilterComponentTypes.CHECKBOXES,
        slot,
        parentKey,
        secondaryGroupKey,
        groupKey,
        data: {
          showInAccordion,
          heading: get(contentLabels, [filterGroupLabel], filterGroupLabel),
          description: get(contentLabels, [filterGroupDescription], filterGroupDescription),
          checkboxes
        },
        defaultLinkedFilters,
        filterByDataMapping,
        combined: isCombined
      },
      config: {
        defaultAppliedFilters,
        createdFilters,
        allLinkedFilters
      }
    } : null;
  }
  createFilterSelectionChips(groupKey, filterGroup, isCombined, contentLabels, showInAccordion, type, filterSourceData, overrideConfig, initialAppliedFilters) {
    const filterByDataMapping = get(filterGroup, 'filterByDataMapping', '');
    const filterGroupLabel = get(filterGroup, 'label', '');
    const filterGroupDescription = get(filterGroup, 'description', '');
    const parentKey = get(filterGroup, 'parentKey', '').toLowerCase();
    const secondaryGroupKey = get(filterGroup, 'secondaryGroupKey', '').toLowerCase();
    const slot = get(filterGroup, 'type', '');
    const rawFilters = get(filterGroup, 'filters', []);
    const filterMapping = get(filterGroup, 'filterByDataMapping', '');
    const secondaryFilterLabels = get(filterGroup, 'secondayFilterLables', []);
    const filters = isArray(rawFilters) ? rawFilters : [rawFilters];
    const allLinkedFilters = [];
    const defaultLinkedFilters = [];
    const defaultAppliedFilters = [];
    const createdFilters = {
      [groupKey]: {
        filterByDataMapping,
        filters: {}
      }
    };
    const items = filters.filter(filter => {
      const isHidden = !!filter && !['true', true].includes(get(filter, 'hidden', false));
      const filterLabel = secondaryFilterLabels.find(label => label.key === filter.key);
      return isHidden && !['true', true].includes(get(filterLabel, 'hidden', false));
    }).map(filter => {
      const key = this.formatFilterKey(filter);
      const rawLabel = get(filter, 'label', '');
      let label = '';
      if (secondaryFilterLabels.length > 0) {
        const secondaryFilter = secondaryFilterLabels.find(label => label.key === key);
        label = get(secondaryFilter, 'value', rawLabel);
      } else {
        label = get(contentLabels, [rawLabel], rawLabel);
      }
      const isDefault = get(filterGroup, 'default', '').toString().toLowerCase().split(',').includes(key);
      let isActive = false;
      if (overrideConfig) {
        isActive = this.searchFilterCriteria(filter, parentKey, groupKey, initialAppliedFilters);
      } else if (isDefault) {
        isActive = true;
        defaultAppliedFilters.push({
          key,
          label,
          parentKey,
          secondaryGroupKey,
          groupKey,
          slot: parentKey ? '' : slot,
          filterMapping
        });
      }
      const linkedFilters = this.parseLinkedFilters(groupKey, filter, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters);
      const linkedFilterComponents = [];
      linkedFilters.forEach(linkedFilter => {
        linkedFilterComponents.push(linkedFilter.component);
        defaultAppliedFilters.push(...linkedFilter.config.defaultAppliedFilters);
        const linkedFilterGroup = get(linkedFilter, ['config', 'createdFilters', groupKey, 'filters']);
        for (const key in linkedFilterGroup) {
          if (linkedFilterGroup.hasOwnProperty(key)) {
            createdFilters[groupKey].filters[key] = {
              label: linkedFilterGroup[key].label,
              slot: ''
            };
          }
        }
      });
      allLinkedFilters.push(...linkedFilterComponents);
      if (isActive) {
        defaultLinkedFilters.push(...linkedFilterComponents);
      }
      const formattedKey = parentKey ? `${parentKey}${this.KEY_SEPARATOR}${key}` : key;
      set(createdFilters, [groupKey, 'filters', formattedKey], {
        label,
        slot
      });
      return {
        label,
        isActive,
        image: get(filter, 'image'),
        customEventDetail: {
          key: formattedKey,
          slot,
          linkedFilters: linkedFilterComponents,
          parentKey,
          secondaryGroupKey,
          groupKey,
          filterMapping
        }
      };
    });
    return items.length > 0 ? {
      component: {
        type: GdsFilterComponentTypes.SELECTION_CHIPS,
        slot,
        parentKey,
        secondaryGroupKey,
        groupKey,
        data: {
          showInAccordion,
          type,
          header: {
            heading: get(contentLabels, [filterGroupLabel], filterGroupLabel),
            description: get(contentLabels, [filterGroupDescription], filterGroupDescription)
          },
          items
        },
        defaultLinkedFilters,
        filterByDataMapping,
        combined: isCombined
      },
      config: {
        defaultAppliedFilters,
        createdFilters,
        allLinkedFilters
      }
    } : null;
  }
  createDropdown(groupKey, filterGroup, isCombined, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters) {
    const filterType = get(filterGroup, 'filterType', '');
    const filterByDataMapping = get(filterGroup, 'filterByDataMapping', '');
    const filterGroupLabel = get(filterGroup, 'label', '');
    const filterGroupDescription = get(filterGroup, 'description', '');
    const parentKey = get(filterGroup, 'parentKey', '').toLowerCase();
    const secondaryGroupKey = get(filterGroup, 'secondaryGroupKey', '').toLowerCase();
    const slot = get(filterGroup, 'type', '');
    const rawFilters = get(filterGroup, 'filters', []);
    const filterMapping = get(filterGroup, 'filterByDataMapping', '');
    const secondaryFilterLabels = get(filterGroup, 'secondayFilterLables', []);
    const filters = isArray(rawFilters) ? rawFilters : [rawFilters];
    const allLinkedFilters = [];
    const defaultLinkedFilters = [];
    const defaultAppliedFilters = [];
    const createdFilters = {
      [groupKey]: {
        filterByDataMapping,
        filters: {}
      }
    };
    let selectedOptionIndex = -1;
    let defaultVal = 'placeholder';
    let type = '';
    if (filterType === 'dropdown_min') {
      type = 'min';
    } else if (filterType === 'dropdown_max') {
      type = 'max';
    }
    const options = filters.filter(filter => {
      const isHidden = !!filter && !['true', true].includes(get(filter, 'hidden', false));
      const filterLabel = secondaryFilterLabels.find(label => label.key === filter.key);
      return isHidden && !['true', true].includes(get(filterLabel, 'hidden', false));
    }).map((filter, index) => {
      const key = this.formatFilterKey(filter);
      const prefixedKey = type + key;
      const rawLabel = get(filter, 'label', '');
      let label = '';
      if (secondaryFilterLabels.length > 0) {
        const secondaryFilter = secondaryFilterLabels.find(label => label.key === key);
        label = get(secondaryFilter, 'value', rawLabel);
      } else {
        label = get(contentLabels, [rawLabel], rawLabel);
      }
      const isPlaceholder = key.includes('#placeholder#');
      const isDefault = get(filterGroup, 'default', '').toString().toLowerCase().split(',').includes(key);
      let isSelected = false;
      if (overrideConfig) {
        isSelected = this.searchFilterCriteria({
          ...filter,
          key: prefixedKey
        }, parentKey, groupKey, initialAppliedFilters);
      } else if (isDefault) {
        isSelected = true;
        if (!isPlaceholder) {
          defaultAppliedFilters.push({
            key: prefixedKey,
            label,
            parentKey,
            secondaryGroupKey,
            groupKey,
            slot: parentKey ? '' : slot,
            filterMapping
          });
        }
      }
      const linkedFilters = this.parseLinkedFilters(groupKey, filter, contentLabels, filterSourceData, overrideConfig, initialAppliedFilters);
      const linkedFilterComponents = [];
      linkedFilters.forEach(linkedFilter => {
        linkedFilterComponents.push(linkedFilter.component);
        defaultAppliedFilters.push(...linkedFilter.config.defaultAppliedFilters);
        const linkedFilterGroup = get(linkedFilter, ['config', 'createdFilters', groupKey, 'filters']);
        for (const key in linkedFilterGroup) {
          if (linkedFilterGroup.hasOwnProperty(key)) {
            createdFilters[groupKey].filters[key] = {
              label: linkedFilterGroup[key].label,
              slot: ''
            };
          }
        }
      });
      allLinkedFilters.push(...linkedFilterComponents);
      if (isSelected) {
        selectedOptionIndex = index;
        defaultLinkedFilters.push(...linkedFilterComponents);
        if (!isPlaceholder) {
          defaultVal = key;
        }
      }
      const formattedKey = parentKey ? `${parentKey}${this.KEY_SEPARATOR}${prefixedKey}` : key;
      set(createdFilters, [groupKey, 'filters', formattedKey], {
        label,
        slot
      });
      const value = isPlaceholder ? 'placeholder' : key;
      return {
        label,
        value,
        isSelected,
        customEventDetail: {
          key: formattedKey,
          slot,
          linkedFilters: linkedFilterComponents,
          parentKey,
          secondaryGroupKey,
          groupKey,
          filterMapping,
          type
        }
      };
    });
    return options.length > 0 ? {
      component: {
        type: GdsFilterComponentTypes.DROPDOWN,
        slot,
        parentKey,
        secondaryGroupKey,
        groupKey,
        data: {
          default: defaultVal,
          type,
          formField: {
            primaryLabel: get(contentLabels, [filterGroupLabel], filterGroupLabel),
            secondaryText: get(contentLabels, [filterGroupDescription], filterGroupDescription)
          },
          options
        },
        defaultOption: selectedOptionIndex > -1 && options[selectedOptionIndex],
        defaultLinkedFilters,
        filterByDataMapping,
        combined: isCombined
      },
      config: {
        defaultAppliedFilters,
        createdFilters,
        allLinkedFilters
      }
    } : null;
  }
  searchFilter(filterSection, filterKey, groupKey) {
    let filterToReset;
    filterSection.every(section => {
      if (section.type === GdsFilterComponentTypes.SELECTION_CHIPS) {
        const item = section.data.items.find(f => groupKey === f.customEventDetail.groupKey && filterKey === f.customEventDetail.key);
        if (item) {
          filterToReset = item;
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.CHECKBOXES) {
        const checkbox = section.data.checkboxes.find(f => groupKey === f.customEventDetail.groupKey && filterKey === f.customEventDetail.key);
        if (checkbox) {
          filterToReset = checkbox;
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.DROPDOWN) {
        const option = section.data.options.find(f => groupKey === f.customEventDetail.groupKey && filterKey === f.customEventDetail.key);
        if (option) {
          filterToReset = option;
          return false;
        }
      } else if (section.type === GdsFilterComponentTypes.TOGGLE && filterKey === section.data.customEventDetail.key && groupKey === section.data.customEventDetail.groupKey) {
        filterToReset = section.data;
        return false;
      }
      return true;
    });
    return filterToReset;
  }
  /**
   * The function logs DDL events if digital data is enabled.
   * @param {string} eventAction - It could be something like "click", "submit", "filter", etc.
   * @param {string} type - It could be any value that describes the event, such as "click", "submit", "load", etc.
   * @param {any} results - The `results` parameter is an array of data that represents the results.
   */
  logDdlEvents(eventAction, type, results) {
    if (this.appDataLayer.digitalDataEnabled) {
      const eventInfo = this.digitalData.getEventInfoInstance('Filterlist', eventAction, type, '', new Date().toISOString(), results, this.window.document.URL);
      const eventCategory = this.digitalData.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
      const eventData = this.digitalData.getEventInstance(eventInfo, eventCategory);
      this.digitalData.fireEvent(eventData);
    }
  }
  searchFilterCriteria(filter, parentKey, groupKey, appliedFilters) {
    const filterKey = this.formatFilterKey(filter);
    const key = parentKey ? `${parentKey}${this.KEY_SEPARATOR}${filterKey}` : filterKey;
    return !!appliedFilters?.find(f => f.groupKey === groupKey && f.key.toLowerCase() === key.toLowerCase());
  }
  formatFilterKey(filter) {
    return get(filter, 'key', '').toLowerCase().replaceAll(',', this.COMBO_FILTER_KEY_SEPARATOR);
  }
  createTimeElement(hour, time) {
    const parsedDateTime = DateTime.fromFormat(hour, 'yyyy-MM-dd HH:mm:ss', {
      zone: this.appDefaults.UPR_TIME_ZONE
    });
    const iso8601DateTime = parsedDateTime.toISO({
      includeOffset: false
    });
    return `<time datetime="${iso8601DateTime}">${time}</time>`;
  }
  isLocaleUsj() {
    const locale = this.localeService.getFromStorage();
    const language = locale?.language;
    const country = locale?.country;
    return `${language}/${country}` === 'ja/jp';
  }
  formatHours(hours) {
    const formats = ['yyyy-MM-dd HH:mm:ss', 'HH:mm:ss'];
    if (hours.length === 0) {
      return get(this.pageLabels, 'showsAttractionClosed', '');
    }
    return hours.map(hour => {
      const iso = DateTime.fromISO(hour);
      if (iso.isValid) {
        const dt = iso.setZone(this.appDefaults.UPR_TIME_ZONE);
        const timeString = this.isLocaleUsj() ? dt.toLocaleString(DateTime.TIME_24_SIMPLE) : dt.toLocaleString(DateTime.TIME_SIMPLE);
        return this.createTimeElement(hour, timeString);
      }
      for (let i = 0; i < formats.length; i++) {
        const dt = DateTime.fromFormat(hour, formats[i]);
        if (dt.isValid) {
          const timeString = this.isLocaleUsj() ? dt.toLocaleString(DateTime.TIME_24_SIMPLE) : dt.toLocaleString(DateTime.TIME_SIMPLE);
          return this.createTimeElement(hour, timeString);
        }
      }
      return hour;
    }).join(', ');
  }
  updateRangeDropdowns(targetOpt, sections, rangeType) {
    if (!rangeType) return;
    sections.forEach(section => {
      const customEventDetail = get(targetOpt, 'customEventDetail', {});
      const targetGroupKey = get(customEventDetail, 'groupKey', '');
      const targetParentKey = get(customEventDetail, 'parentKey', '');
      const targetSecondaryGroupKey = get(customEventDetail, 'secondaryGroupKey', '');
      const sectionComp = get(section, 'component', section);
      if (sectionComp.type === GdsFilterComponentTypes.DROPDOWN && sectionComp.groupKey === targetGroupKey && sectionComp.parentKey == targetParentKey && sectionComp.secondaryGroupKey == targetSecondaryGroupKey && sectionComp.data.type !== rangeType) {
        sectionComp.data.options.forEach(opt => {
          if (opt.value === 'placeholder') {
            return;
          } else if (targetOpt.value === 'placeholder') {
            opt.disabled = false;
            return;
          } else if (rangeType === 'min') {
            opt.disabled = opt.value < targetOpt.value;
          } else {
            opt.disabled = opt.value > targetOpt.value;
          }
        });
      }
    });
  }
  setDropdownFilterValue(filter, val) {
    if (!filter) return;
    const dropdownElements = this.filterListEl.querySelectorAll('.gds-filter-list-sidebar-sections-containers-container--dropdown gds-dropdown');
    const dropdown = Array.from(dropdownElements).find(el => {
      const options = get(el, 'data.options');
      const customEventDetail = get(options, '0.customEventDetail', {});
      const groupKey = get(customEventDetail, 'groupKey', '');
      const parentKey = get(customEventDetail, 'parentKey', '');
      return groupKey === filter.groupKey && parentKey === filter.parentKey && !!options?.find(opt => get(opt, 'customEventDetail.key') === filter.key);
    });
    if (dropdown) {
      dropdown.value = val;
    }
  }
  static {
    this.ɵfac = function GdsFiltersBaseService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFiltersBaseService)(i0.ɵɵinject('AppDefaults'), i0.ɵɵinject('AppRegexs'), i0.ɵɵinject(WINDOW), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.DalService), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i4.ActivatedRoute), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i5.DigitalDataService), i0.ɵɵinject(i5.AppDataLayerService), i0.ɵɵinject(i6.TcmService), i0.ɵɵinject(i7.GdsCommonUtilityService), i0.ɵɵinject(i8.UprMobileService), i0.ɵɵinject(i9.PageLabelsResolver));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsFiltersBaseService,
      factory: GdsFiltersBaseService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFiltersBaseService, [{
    type: Injectable
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppRegexs']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DalService
  }, {
    type: i2.LocaleService
  }, {
    type: i3.Store
  }, {
    type: i4.Router
  }, {
    type: i4.ActivatedRoute
  }, {
    type: i0.RendererFactory2
  }, {
    type: i5.DigitalDataService
  }, {
    type: i5.AppDataLayerService
  }, {
    type: i6.TcmService
  }, {
    type: i7.GdsCommonUtilityService
  }, {
    type: i8.UprMobileService
  }, {
    type: i9.PageLabelsResolver
  }], null);
})();
class GdsFilterListService extends GdsFiltersBaseService {
  constructor() {
    super(...arguments);
    this.FILTERS_PARAM_NAME = 'filters';
    this.KEY_SEPARATOR = ';';
    this.COMBO_FILTER_KEY_SEPARATOR = ':';
    this.SIDEBAR_PROP_PATH = 'data';
    this.SIDEBAR_DATA_PATH = 'sidebar';
    this.ACTION_TYPE = GdsFilterActionTypes.FILTER_LIST;
  }
  processFilters(element) {
    this.filterListEl = element;
    const flData = this.getComponentData();
    this.defaultTileDisplay = Number(get(flData, 'noOfTiles', 0));
    this.defaultTileView = get(flData, 'tileView.defaultValue');
    const filterBuilderContentID = get(flData, 'filterConfigContentId', '');
    let defaultSortData;
    const sortData = get(flData, 'sort');
    const defaultSortKey = get(sortData, 'defaultValue');
    const rawOptions = get(sortData, 'options', []);
    const sortOptions = isArray(rawOptions) ? rawOptions : [rawOptions];
    const parsedSortOptions = sortOptions.map(opt => {
      const key = get(opt, 'key', '');
      const mapping = get(opt, 'mapping', '');
      const label = get(opt, 'value', '');
      const value = {
        key,
        mapping
      };
      if (defaultSortKey === key) {
        defaultSortData = value;
      }
      return {
        label,
        value: JSON.stringify(value)
      };
    });
    // no results found components
    this.groupedElements = this.noResultsComponents(flData?.noMatchDetail, 'no-match-detail');
    const sortDropdownData = {
      ...flData.controls?.sortDropDown,
      options: parsedSortOptions
    };
    const controlBtn = get(flData, 'tileView.controlBtn', []);
    const controlBtnArr = isArray(controlBtn) ? controlBtn : [controlBtn];
    const segmentedControls = controlBtnArr.map(btn => {
      const iconName = get(btn, 'svgOptions', '');
      return {
        ...btn,
        isActive: iconName === this.defaultTileView,
        customEventDetail: {
          view: iconName
        },
        svgOptions: {
          iconName
        }
      };
    });
    this.displayActiveZone = ['true', true].includes(flData?.displayZone);
    set(flData, 'controls.filterButton.button', flData?.filterButton);
    set(flData, 'controls.filterZone.header', flData?.filterzone);
    this.hashSet(flData, 'controls.header.heading', flData?.heading);
    this.hashSet(flData, 'controls.filterZone.header.heading', get(flData, 'filterzone.heading', ''));
    this.hashSet(flData, 'controls.filterZone.header.description', get(flData, 'filterzone.description', ''));
    this.hashSet(flData, 'items.currentDisplay', flData?.paginateText);
    this.updateDynamicLabels(flData, {
      current: 0,
      total: 0
    });
    if (sortDropdownData.options.length > 1) {
      set(flData, 'controls.sortDropDown', sortDropdownData);
      set(flData, 'controls.defaultSort', JSON.stringify(defaultSortData));
    }
    set(flData, 'controls.controlBtn.segmentedButtons', segmentedControls);
    set(flData, 'controls.displayDateControl', flData?.displayDateControl);
    set(flData, 'items.defaultDisplay', this.defaultTileDisplay);
    set(flData, 'items.button', flData?.loadMoreButton);
    unset(flData, 'displayDateControl');
    unset(flData, 'loadMoreButton');
    unset(flData, 'controlBtn');
    unset(flData, 'filterButton');
    unset(flData, 'tileView');
    unset(flData, 'heading');
    unset(flData, 'sort');
    unset(flData, 'noOfTiles');
    unset(flData, 'paginateText');
    unset(flData, 'displayZone');
    unset(flData, 'filterzone');
    this.init(filterBuilderContentID, defaultSortData);
  }
  init(contentId, defaultSort) {
    this.mapModalElement = this.document.querySelector('.gds-map-container');
    this.filterBuilderContentID = `${contentId}_${this.FILTERS_PARAM_NAME}`;
    GdsFiltersBaseService.filterBuilderContentIds[this.ACTION_TYPE] = this.filterBuilderContentID;
    this.getCache(this.filterBuilderContentID, defaultSort);
    this.subscriptions.add(this.store.pipe(select(getAppliedFilters(this.filterBuilderContentID))).subscribe(data => {
      this.appliedFilters = data;
      this.filterListEl.filters = JSON.stringify(data);
      const flData = this.getComponentData();
      if (!!flData && this.displayActiveZone) {
        unset(flData, 'controls.filterButton.bubbleBadge.label');
        unset(flData, 'controls.filterZone.filterChips');
        set(flData, 'controls.filterButton.bubbleBadge.label', data?.length?.toString());
        set(flData, 'controls.filterButton.bubbleBadge.style', 'Default2');
        set(flData, 'controls.filterZone.filterChips', data);
        this.filterListEl.data = JSON.stringify(flData);
      }
    }));
    this.subscriptions.add(combineLatest([this.store.pipe(select(getFilterGroups(this.filterBuilderContentID))), this.store.pipe(select(getAllLinkedFilters(this.filterBuilderContentID)))]).subscribe(([filterGroups, allLinkedFilters]) => {
      const sidebarData = this.getSidebarData();
      const oldSidebarSections = get(sidebarData, 'sections');
      if (filterGroups?.length && JSON.stringify(filterGroups) !== JSON.stringify(oldSidebarSections)) {
        const updatedSidebarSections = {
          ...sidebarData,
          sections: filterGroups
        };
        this.setClearedFiltersState(updatedSidebarSections, allLinkedFilters);
        this.selectedFilters = [...this.appliedFilters];
        this.setSidebarData(this.filterSecondaryFilters(updatedSidebarSections));
        this.setInStore(this.filterBuilderContentID);
      }
    }));
    this.subscriptions.add(this.store.pipe(select(getFilterTileData(this.filterBuilderContentID))).subscribe(tileData => {
      const updateResults = get(tileData, 'updateResults', false);
      const results = get(tileData, 'filteredTiles');
      const requestedTiles = get(tileData, 'requestedTiles', 0);
      const total = results?.length || 0;
      const flData = this.getComponentData();
      this.updateDynamicLabels(flData, {
        current: Math.min(requestedTiles, total),
        total
      });
      if (results && requestedTiles >= total) {
        set(flData, 'items.disableLoadMore', true);
      } else {
        set(flData, 'items.disableLoadMore', false);
      }
      if (!updateResults) return;
      const view = get(tileData, 'view', '');
      if (view) {
        const segmentedButtons = get(flData, 'controls.controlBtn.segmentedButtons', []).map(btn => ({
          ...btn,
          isActive: view === get(btn, 'customEventDetail.view', '')
        }));
        set(flData, 'controls.controlBtn.segmentedButtons', segmentedButtons);
      }
      if (results?.length) {
        this.groupedElements.setAttribute('style', 'display: none;');
        const sortVal = get(tileData, 'sortData.value');
        const cardType = get(tileData, 'cardType');
        set(flData, 'items.total', results.length);
        set(flData, 'items.cardType', cardType);
        this.filterListEl.data = JSON.stringify(flData);
        const diplayedResults = results.slice(0, requestedTiles);
        this.filterListEl.items = JSON.stringify(diplayedResults);
        const sortDropdown = this.filterListEl.querySelector('.gds-filter-list-controls-sort');
        if (sortVal && sortDropdown && sortVal !== sortDropdown.getAttribute('value')) {
          sortDropdown.setAttribute('value', sortVal);
        }
      } else if (results?.length === 0) {
        this.filterListEl.items = null;
        this.filterListEl.data = JSON.stringify(flData);
        this.groupedElements.setAttribute('style', 'display: block;');
        const eleToAppend = this.filterListEl.querySelector('.gds-filter-list-elements');
        eleToAppend?.appendChild(this.groupedElements);
      }
    }));
    this.registerEvents();
  }
  updateResults(btnData) {
    const currentItems = Number(get(btnData, 'customEventDetail.currentLength', 0));
    const requestedTiles = get(btnData, 'customEventDetail.requestingLength', 0) || currentItems + this.defaultTileDisplay;
    this.logDdlEvents('Load More Button', 'Click', `currentItems are ${currentItems} & requesting ${requestedTiles}`);
    this.store.dispatch(SetRequestedTiles({
      contentId: this.filterBuilderContentID,
      requestedTiles,
      actionType: this.ACTION_TYPE
    }));
  }
  applyDefaultView() {
    this.dispatchAction(ChangeFilterTileView({
      contentId: this.filterBuilderContentID,
      view: this.defaultTileView,
      actionType: this.ACTION_TYPE
    }));
  }
  registerEvents() {
    this.applyFilters = fromEvent(this.filterListEl, 'filterSidebarPrimaryButton');
    this.sidebarClose = fromEvent(this.filterListEl, 'closeFilterSidebar');
    this.sidebarOpen = fromEvent(this.filterListEl, 'openFilterSidebar');
    this.clearFiltersFromSidebar = fromEvent(this.filterListEl, 'filterSidebarSecondaryButton');
    this.clearFiltersFromZone = fromEvent(this.filterListEl, 'filterZoneClearButton');
    this.filterChange = fromEvent(this.filterListEl, 'filterChanged');
    this.deleteFilter = fromEvent(this.filterListEl, 'filterChipClosed');
    this.sortChange = fromEvent(this.filterListEl, 'valueChange');
    this.tileViewChange = fromEvent(this.filterListEl, 'segmentedButtonSelected');
    this.handleEvents();
  }
  dispatchAction(act) {
    this.store.dispatch(act);
  }
  handleEvents() {
    this.subscriptions.add(this.applyFilters.subscribe(() => {
      this.toggleSidebar(false);
      this.appliedFilters = this.selectedFilters;
      this.prevSidebarData = null;
      this.setInStore(this.filterBuilderContentID);
      this.store.dispatch(FilterTiles({
        contentId: this.filterBuilderContentID,
        actionType: this.ACTION_TYPE,
        filterGroups: this.getSidebarData()?.sections
      }));
    }));
    this.subscriptions.add(this.sidebarClose.subscribe(() => {
      this.toggleSidebar(false);
      this.selectedFilters = [];
      if (this.prevSidebarData) {
        this.setSidebarData(this.prevSidebarData);
        this.prevSidebarData = null;
      }
    }));
    this.subscriptions.add(this.clearFiltersFromSidebar.subscribe(() => {
      this.toggleSidebar(false);
      this.clearFilters();
    }));
    this.subscriptions.add(this.clearFiltersFromZone.subscribe(() => {
      this.clearFilters();
    }));
    this.subscriptions.add(this.sidebarOpen.subscribe(() => {
      this.selectedFilters = this.appliedFilters;
      this.prevSidebarData = this.getComponentData()?.sidebar;
      this.toggleSidebar(true);
    }));
    this.subscriptions.add(this.deleteFilter.subscribe(data => this.deleteFilterHandler(data.detail)));
    this.subscriptions.add(this.filterChange.subscribe(data => this.filterChangedHandler(data.detail)));
    this.subscriptions.add(this.sortChange.subscribe(event => {
      const elem = event?.target;
      if (elem?.classList?.contains('gds-filter-list-controls-sort')) {
        const sortData = JSON.parse(get(event, 'detail', '{}'));
        this.setSortedTiles(this.filterBuilderContentID, sortData);
      }
    }));
    this.subscriptions.add(this.tileViewChange.subscribe(event => {
      const selectedView = get(event, 'detail.button.customEventDetail.view');
      if (!selectedView) return;
      this.store.dispatch(ChangeFilterTileView({
        contentId: this.filterBuilderContentID,
        view: selectedView,
        actionType: this.ACTION_TYPE
      }));
      if (selectedView === 'map-view') {
        this.updateQueryParams(this.appliedFilters, 'gmapFilters')?.subscribe(() => {
          sendEvent('OPEN_GDS_INTERACTIVE_MAP_GLOBAL', {
            contentId: this.filterBuilderContentID,
            filterListView: true
          });
        });
      }
    }));
  }
  /**
   * Determines whether a given tile should be included based on its place type.
   *
   * @returns boolean
   */
  applyInternalFilters(tile, opts) {
    const placeType = get(tile, 'place.place_type.type', '').toLowerCase();
    if (opts && ['land', 'park', 'hotel'].includes(placeType)) {
      return !!opts.isMapView;
    }
    return null;
  }
  applyInternalLinkedFilters(tile, path, key) {
    const placeId = get(tile, 'place.place_id', '');
    const placeType = get(tile, 'place.place_type.type', '').toLowerCase();
    if (path === 'place.land_id') {
      if (placeType === 'land') {
        return placeId === key;
      }
      if (placeType === 'park') {
        return key.includes(placeId);
      }
    }
    return false;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵGdsFilterListService_BaseFactory;
      return function GdsFilterListService_Factory(__ngFactoryType__) {
        return (ɵGdsFilterListService_BaseFactory || (ɵGdsFilterListService_BaseFactory = i0.ɵɵgetInheritedFactory(GdsFilterListService)))(__ngFactoryType__ || GdsFilterListService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsFilterListService,
      factory: GdsFilterListService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFilterListService, [{
    type: Injectable
  }], null, null);
})();
const initialState = {
  apiCache: {}
};
const initialFilterSourceState = {
  config: null,
  filterSource: [],
  loading: false
};
const reducers = createReducer(initialState, on(LoadConfig, (state, {
  contentId,
  defaultSort,
  defaultDisplay,
  element
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    loading: true,
    loaded: false,
    element,
    error: '',
    filterTileData: {
      sortData: defaultSort,
      defaultDisplay,
      requestedTiles: defaultDisplay
    }
  }
})), on(DefaultConfigSuccess, (state, {
  config,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterConfig: config,
    loading: true,
    loaded: true
  }
})), on(DefaultConfigFailure, (state, {
  error,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    error,
    loading: false,
    loaded: false
  }
})), on(SetFilterElement, (state, {
  contentId,
  element
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    element
  }
})), on(LoadContentLabelsSuccess, (state, {
  contentLabels,
  contentId,
  apiCache
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    contentLabels,
    loading: true
  },
  apiCache: {
    ...state.apiCache,
    ...apiCache
  }
})), on(LoadContentLabelsFailure, (state, {
  error,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    error,
    loading: false,
    loaded: false
  }
})), on(LoadFilterTileDataSuccess, (state, {
  filterTileData,
  contentId,
  apiCache
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      ...filterTileData
    },
    loading: true
  },
  apiCache: {
    ...state.apiCache,
    ...apiCache
  }
})), on(LoadFilterTileDataFailure, (state, {
  error,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    error,
    loading: false,
    loaded: false
  }
})), on(LoadFilterTileDataWithContentLabelsSuccess, (state, {
  contentId,
  filterTileData,
  contentLabels,
  apiCache
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      ...filterTileData
    },
    contentLabels,
    loading: true
  },
  apiCache: {
    ...state.apiCache,
    ...apiCache
  }
})), on(LoadFilterTileDataWithContentLabelsFailure, (state, {
  error,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    error,
    loading: false,
    loaded: false
  }
})), on(ChangeFilterTileViewSuccess, (state, {
  filterTileData,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      ...filterTileData,
      updateResults: false
    }
  }
})), on(LoadAllFilterGroupSourcesSuccess, (state, {
  filterGroups,
  contentId,
  apiCache
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterGroups,
    loading: false,
    loaded: true
  },
  apiCache: {
    ...state.apiCache,
    ...apiCache
  }
})), on(LoadAllFilterGroupSourcesFailure, (state, {
  error,
  contentId
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    error,
    loading: false,
    loaded: false
  }
})), on(InitQueryParams, (state, {
  contentId,
  filtersParamName
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filtersParamName
  }
})), on(SetAllFilters, (state, {
  contentId,
  allFilters,
  allLinkedFilters
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    allFilters,
    allLinkedFilters
  }
})), on(SetAppliedFilters, (state, {
  contentId,
  appliedFilters,
  overrideConfig
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    appliedFilters,
    overrideConfig
  }
})), on(SetSelectedFilters, (state, {
  contentId,
  selectedFilters
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    selectedFilters
  }
})), on(SetRequestedTiles, (state, {
  contentId,
  requestedTiles
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      requestedTiles,
      updateResults: true
    }
  }
})), on(SetSortData, (state, {
  contentId,
  sortData
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      sortData,
      updateResults: false
    }
  }
})), on(SortFilterTiles, (state, {
  contentId,
  sortedTiles
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      sortedTiles,
      updateResults: false
    }
  }
})), on(FilterTiles, (state, {
  contentId,
  filterGroups,
  newAppliedFilters
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterGroups,
    newAppliedFilters: newAppliedFilters ?? []
  }
})), on(FilterTilesSuccess, (state, {
  contentId,
  filteredTiles
}) => ({
  ...state,
  [contentId]: {
    ...state[contentId],
    filterTileData: {
      ...state[contentId]?.filterTileData,
      filteredTiles,
      updateResults: true
    }
  }
})));
class GdsInteractiveMapFilterService extends GdsFiltersBaseService {
  constructor(appDefaults, appRegExs, window, document, dal, localeService, store, router, route, renderer, digitalData, appDataLayer, tridion, utilities, mobileService, pageLabelsResolver) {
    super(appDefaults, appRegExs, window, document, dal, localeService, store, router, route, renderer, digitalData, appDataLayer, tridion, utilities, mobileService, pageLabelsResolver);
    this.appDefaults = appDefaults;
    this.appRegExs = appRegExs;
    this.window = window;
    this.document = document;
    this.dal = dal;
    this.localeService = localeService;
    this.store = store;
    this.router = router;
    this.route = route;
    this.renderer = renderer;
    this.digitalData = digitalData;
    this.appDataLayer = appDataLayer;
    this.tridion = tridion;
    this.utilities = utilities;
    this.mobileService = mobileService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.FILTERS_PARAM_NAME = 'mapFilters';
    this.KEY_SEPARATOR = ';';
    this.COMBO_FILTER_KEY_SEPARATOR = ':';
    this.SIDEBAR_DATA_PATH = '';
    this.SIDEBAR_PROP_PATH = 'sidebarData';
    this.ACTION_TYPE = GdsFilterActionTypes.INTERACTIVE_MAP;
  }
  processFilters(element) {
    this.filterListEl = element;
    const flData = this.getComponentData('tridionData');
    this.defaultTileDisplay = Number(get(flData, 'noOfTiles', 0));
    this.defaultTileView = get(flData, 'tileView.defaultValue');
    const filterBuilderContentID = get(flData, 'filterConfigContentId', '');
    // no results found components
    this.groupedElements = this.noResultsComponents(flData?.noMatchDetail, 'no-match-detail');
    const controlBtn = get(flData, 'tileView.controlBtn', []);
    const controlBtnArr = isArray(controlBtn) ? controlBtn : [controlBtn];
    const segmentedControls = controlBtnArr.map(btn => {
      const iconName = get(btn, 'svgOptions', '');
      return {
        ...btn,
        isActive: iconName === this.defaultTileView,
        customEventDetail: {
          view: iconName
        },
        svgOptions: {
          iconName
        }
      };
    });
    // TODO: Figure out if active filter zone should be optional for iMap.
    // this.displayActiveZone = ['true', true].includes(flData?.displayZone);
    this.displayActiveZone = true;
    set(flData, 'filterButton.button', flData?.filterButton);
    this.hashSet(flData, 'heading', flData?.heading);
    this.updateDynamicLabels(flData, {
      current: -1,
      total: -1
    });
    const heading = get(flData, 'noMatchDetail.noMatchContent.heading');
    const description = get(flData, 'noMatchDetail.noMatchContent.shortDescription');
    const loadingMoreCardsText = get(flData, 'loadingMoreCardsText', '');
    const cardContainerData = {
      emptyMapCardsData: {
        heading,
        description
      },
      loadingMoreCardsText
    };
    set(flData, 'controls.controlBtn.segmentedButtons', segmentedControls);
    set(flData, 'controls.displayDateControl', flData?.displayDateControl);
    set(flData, 'items.defaultDisplay', this.defaultTileDisplay);
    set(flData, 'items.button', flData?.loadMoreButton);
    set(flData, 'cardContainerData', cardContainerData);
    set(flData, 'closeMapModalAriaLabel', this.pageLabels?.txtCloseModal);
    set(flData, 'expandButtonAriaLabel', this.pageLabels?.expandMap);
    set(flData, 'filterButtonAriaLabel', this.pageLabels?.lblFilterActive);
    unset(flData, 'displayDateControl');
    unset(flData, 'loadMoreButton');
    unset(flData, 'controlBtn');
    unset(flData, 'filterButton');
    unset(flData, 'tileView');
    unset(flData, 'sort');
    unset(flData, 'noOfTiles');
    unset(flData, 'paginateText');
    unset(flData, 'displayZone');
    unset(flData, 'filterzone');
    this.setSidebarData(flData?.sidebar);
    this.setZoomControlsData(flData);
    this.filterListEl.data = JSON.stringify(flData);
    this.init(filterBuilderContentID);
  }
  init(contentId) {
    this.filterListView = JSON.parse(get(this.route.snapshot.queryParams, 'isFilterListView', 'false'));
    GdsFiltersBaseService.filterBuilderContentIds[this.ACTION_TYPE] = this.filterBuilderContentID;
    if (this.filterListView) {
      this.filterBuilderContentID = get(GdsFiltersBaseService.filterBuilderContentIds, 'filter-list', contentId);
    } else {
      this.filterBuilderContentID = `${contentId}_${this.FILTERS_PARAM_NAME}`;
      this.getCache(this.filterBuilderContentID);
    }
    this.subscriptions.add(this.store.pipe(select(getAppliedFilters(this.filterBuilderContentID))).subscribe(data => {
      this.appliedFilters = data;
      const flData = this.getComponentData();
      const filterZoneData = this.getComponentData('activeFilterZone');
      const filterButton = this.filterListEl.querySelector('.gds-map-container-filter-button');
      if (this.displayActiveZone) {
        const updatedFilterZone = {
          ...filterZoneData,
          filterChips: data
        };
        this.filterListEl.activeFilterZone = JSON.stringify(updatedFilterZone);
      }
      if (flData && filterButton) {
        const badgeData = {
          label: data?.length?.toString(),
          style: 'Default2'
        };
        filterButton.badge = JSON.stringify(badgeData);
      }
    }));
    this.subscriptions.add(combineLatest([this.store.pipe(select(getFilterGroups(this.filterBuilderContentID))), this.store.pipe(select(getAllLinkedFilters(this.filterBuilderContentID)))]).subscribe(([filterGroups, allLinkedFilters]) => {
      const sidebarData = this.getSidebarData();
      const oldSidebarSections = get(sidebarData, 'sections');
      if (filterGroups && JSON.stringify(filterGroups) !== JSON.stringify(oldSidebarSections)) {
        const updatedSidebarSections = {
          ...sidebarData,
          sections: filterGroups
        };
        this.setClearedFiltersState(updatedSidebarSections, allLinkedFilters);
        this.selectedFilters = [...this.appliedFilters];
        this.setSidebarData(this.filterSecondaryFilters(updatedSidebarSections));
      }
    }));
    this.subscriptions.add(this.store.pipe(select(getFilterTileData(this.filterBuilderContentID))).subscribe(tileData => {
      const updateResults = get(tileData, 'updateResults', false);
      const results = get(tileData, 'filteredTiles');
      if (!updateResults) return;
      const filteredResults = results.filter(item => {
        return item.pin?.placeType !== 'Park' && item.pin?.placeType !== 'Land' && item.pin?.placeType !== 'Hotel' && item.pin?.location?.lat && item.pin?.location?.lng;
      });
      const total = filteredResults?.length || 0;
      const flData = this.getComponentData();
      this.updateDynamicLabels(flData, {
        current: total,
        total
      });
      const view = get(tileData, 'view', '');
      if (view) {
        const segmentedButtons = get(flData, 'controls.controlBtn.segmentedButtons', []).map(btn => ({
          ...btn,
          isActive: view === get(btn, 'customEventDetail.view', '')
        }));
        set(flData, 'controls.controlBtn.segmentedButtons', segmentedButtons);
      }
      if (results?.length) {
        this.groupedElements.setAttribute('style', 'display: none;');
        this.filterListEl.data = JSON.stringify(flData);
        this.filterListEl.mapCards = JSON.stringify(results);
      } else if (results?.length === 0) {
        this.filterListEl.data = JSON.stringify(flData);
        this.filterListEl.mapCards = [];
        this.groupedElements.setAttribute('style', 'display: block;');
        const eleToAppend = this.filterListEl.querySelector('.gds-filter-list-elements');
        eleToAppend?.appendChild(this.groupedElements);
      }
    }));
    this.getMapCards$ = this.store.pipe(select(getFilterTileData(this.filterBuilderContentID)), filter(res => res.updateResults), withLatestFrom(this.store.select(getNewAppliedFilters(this.filterBuilderContentID))), map(([res, newAppliedFilters]) => ({
      mapCards: res.filteredTiles,
      newAppliedFilters
    })));
    this.registerEvents();
  }
  /**
   * Getting all applied filters and ensuring park & land data is never filtered out.
   *
   * @returns AppliedFilters
   */
  getAppliedFilters(appliedFilters, allFilters, allLinkedFilters) {
    const {
      filters,
      activeLinkedFilters
    } = super.getAppliedFilters(appliedFilters, allFilters, allLinkedFilters);
    for (const groupKey in filters) {
      const filter = filters[groupKey];
      if (filter.path === 'place.place_type.type') {
        filter.keys.push('park', 'land', 'hotel');
        break;
      }
    }
    return {
      filters,
      activeLinkedFilters
    };
  }
  applyInternalLinkedFilters(tile, path, key) {
    const placeId = get(tile, 'place.place_id', '');
    const placeType = get(tile, 'place.place_type.type', '').toLowerCase();
    if (path === 'place.land_id') {
      if (placeType === 'land') {
        return placeId === key;
      }
      if (placeType === 'park') {
        return key.includes(placeId);
      }
    }
    return false;
  }
  applyInternalFilters(tile, _opts) {
    const placeType = get(tile, 'place.place_type.type', '').toLowerCase();
    if (['land', 'park', 'hotel'].includes(placeType)) {
      return true;
    }
    return null;
  }
  sortTiles(filterTileData) {
    const currTiles = get(filterTileData, 'results', []);
    if (!this.centerPoint) {
      return currTiles;
    }
    return currTiles.toSorted((tile1, tile2) => {
      const tileLocation1 = get(tile1, 'pin.location');
      const x1 = get(tileLocation1, 'lat', 0);
      const y1 = get(tileLocation1, 'lng', 0);
      const tileLocation2 = get(tile2, 'pin.location');
      const x2 = get(tileLocation2, 'lat', 0);
      const y2 = get(tileLocation2, 'lng', 0);
      const distance1 = Math.hypot(x1 - this.centerPoint.x, y1 - this.centerPoint.y);
      const distance2 = Math.hypot(x2 - this.centerPoint.x, y2 - this.centerPoint.y);
      return distance1 > distance2 ? 1 : -1;
    });
  }
  /**
   * Method used to sort tiles after receiving new center point within map.
   * @param x
   * @param y
   */
  setCenterPoint(x, y) {
    this.centerPoint = {
      x,
      y
    };
    this.store.dispatch(SetSortData({
      contentId: this.filterBuilderContentID,
      actionType: this.ACTION_TYPE
    }));
  }
  registerEvents() {
    this.applyFilters = fromEvent(this.filterListEl, 'filterSidebarPrimaryButton');
    this.sidebarClose = fromEvent(this.filterListEl, 'closeFilterSidebar');
    this.sidebarOpen = fromEvent(this.filterListEl, 'filterButtonClicked');
    this.clearFiltersFromSidebar = fromEvent(this.filterListEl, 'filterSidebarSecondaryButton');
    this.filterChange = fromEvent(this.filterListEl, 'filterChanged');
    this.deleteFilter = fromEvent(this.filterListEl, 'filterChipClosed');
    this.handleEvents();
  }
  toggleSidebar(state) {
    if (this.filterListEl) {
      this.isSidebarOpen = state;
      this.filterListEl.sidebarOpen = state;
    }
  }
  dispatchAction(act) {
    this.store.dispatch(act);
  }
  handleEvents() {
    this.subscriptions.add(this.applyFilters.subscribe(() => {
      this.toggleSidebar(false);
      const newAppliedFilters = this.getNewAppliedFilters();
      this.appliedFilters = this.selectedFilters;
      this.prevSidebarData = null;
      this.setInStore(this.filterBuilderContentID);
      this.store.dispatch(FilterTiles({
        contentId: this.filterBuilderContentID,
        actionType: this.ACTION_TYPE,
        filterGroups: this.getSidebarData()?.sections,
        newAppliedFilters
      }));
    }));
    this.subscriptions.add(this.sidebarClose.subscribe(() => {
      this.toggleSidebar(false);
      this.selectedFilters = [];
      if (this.prevSidebarData) {
        this.setSidebarData(this.prevSidebarData);
        this.prevSidebarData = null;
      }
    }));
    this.subscriptions.add(this.clearFiltersFromSidebar.subscribe(() => {
      this.toggleSidebar(false);
      this.clearFilters();
    }));
    this.subscriptions.add(this.sidebarOpen.subscribe(() => {
      this.selectedFilters = this.appliedFilters;
      this.prevSidebarData = this.getSidebarData();
      this.toggleSidebar(true);
    }));
    this.subscriptions.add(this.deleteFilter.subscribe(data => this.deleteFilterHandler(data.detail)));
    this.subscriptions.add(this.filterChange.subscribe(data => this.filterChangedHandler(data.detail)));
  }
  /**
   * method to grab all of the selected filters that did not already exist within the applied filters list.
   *
   * @returns AppliedFilter[]
   */
  getNewAppliedFilters() {
    return this.selectedFilters.filter(selectedFilter => {
      return !this.appliedFilters.find(appliedFilter => appliedFilter.groupKey === selectedFilter.groupKey && appliedFilter.parentKey === selectedFilter.parentKey && appliedFilter.key === selectedFilter.key);
    });
  }
  setZoomControlsData(data) {
    const zoomControlsData = {
      segmentedButtons: [{
        svgOptions: {
          iconName: 'add'
        },
        ariaLabel: this.pageLabels?.increaseZoom
      }, {
        svgOptions: {
          iconName: 'subtract'
        },
        ariaLabel: this.pageLabels?.decreaseZoom
      }]
    };
    if (!data.hasOwnProperty('zoomControls')) {
      set(data, 'zoomControls', zoomControlsData);
    }
  }
  /**
   * The function logs DDL events if digital data is enabled.
   * @param {string} eventAction - It could be something like "click", "submit", "filter", etc.
   * @param {string} type - It could be any value that describes the event, such as "click", "submit", "load", etc.
   * @param {any} results - The `results` parameter is an array of data that represents the results.
   */
  logDdlEvents(eventAction, type, results) {
    if (this.appDataLayer.digitalDataEnabled) {
      const eventInfo = this.digitalData.getEventInfoInstance('Interactive Map', eventAction, type, '', new Date().toISOString(), results, this.window.document.URL);
      const eventCategory = this.digitalData.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
      const eventData = this.digitalData.getEventInstance(eventInfo, eventCategory);
      this.digitalData.fireEvent(eventData);
    }
  }
  /** replaces children of "filterListEl" with "configured Elements on err" */
  displayErrorMessage(aui) {
    this.filterListEl = this.document.querySelector(`[data-aui="${aui}"]`);
    if (!this.filterListEl) return;
    if (this.filterListEl.pageView) return super.displayErrorMessage(aui);
    const flData = this.getComponentData();
    const configErrorElement = this.noResultsComponents(flData?.errorDetail, 'gds-filter-config-failed');
    this.filterListEl.querySelector('.gds-map-container-relative')?.replaceChildren(configErrorElement);
    this.filterListEl.data = '{}';
  }
  static {
    this.ɵfac = function GdsInteractiveMapFilterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInteractiveMapFilterService)(i0.ɵɵinject('AppDefaults'), i0.ɵɵinject('AppRegexs'), i0.ɵɵinject(WINDOW), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.DalService), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i4.ActivatedRoute), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i5.DigitalDataService), i0.ɵɵinject(i5.AppDataLayerService), i0.ɵɵinject(i6.TcmService), i0.ɵɵinject(i7.GdsCommonUtilityService), i0.ɵɵinject(i8.UprMobileService), i0.ɵɵinject(i9.PageLabelsResolver));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsInteractiveMapFilterService,
      factory: GdsInteractiveMapFilterService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInteractiveMapFilterService, [{
    type: Injectable
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppRegexs']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DalService
  }, {
    type: i2.LocaleService
  }, {
    type: i3.Store
  }, {
    type: i4.Router
  }, {
    type: i4.ActivatedRoute
  }, {
    type: i0.RendererFactory2
  }, {
    type: i5.DigitalDataService
  }, {
    type: i5.AppDataLayerService
  }, {
    type: i6.TcmService
  }, {
    type: i7.GdsCommonUtilityService
  }, {
    type: i8.UprMobileService
  }, {
    type: i9.PageLabelsResolver
  }], null);
})();
class GdsFiltersBaseEffects {
  constructor(actions$, filterService, store$, spinner) {
    this.actions$ = actions$;
    this.filterService = filterService;
    this.store$ = store$;
    this.spinner = spinner;
    this.loadConfig$ = createEffect(() => this.actions$.pipe(ofType(LoadConfig), filter(({
      actionType
    }) => this.effectType === actionType), tap(() => this.spinner.show()), concatMap(({
      contentId,
      actionType,
      element,
      filtersParamName
    }) => this.filterService.getFilterBuilderConfig(contentId, filtersParamName).pipe(map(config => {
      if (config) {
        this.filterService.logDdlEvents('Success', 'Filter builder config loaded', '');
        return DefaultConfigSuccess({
          config,
          contentId,
          actionType
        });
      }
      this.spinner.hide();
      return DefaultConfigFailure({
        error: 'Failed to load filter builder config',
        contentId,
        actionType
      });
    }), catchError(error => {
      this.spinner.hide();
      this.filterService.displayErrorMessage(element);
      this.filterService.logDdlEvents('Error', 'Failed to load filter config', error.message);
      return of(DefaultConfigFailure({
        error: error.message,
        contentId,
        actionType
      }));
    })))));
    this.loadContentLabels$ = createEffect(() => this.actions$.pipe(ofType(DefaultConfigSuccess, LoadContentLabels), filter(({
      actionType
    }) => this.effectType === actionType), withLatestFrom(this.store$.pipe(select(getApiCache))), concatMap(([{
      config,
      contentId,
      actionType
    }, currApiCache]) => {
      return this.filterService.getContentLabels(config.contentLabelsUrl, currApiCache).pipe(map(({
        contentLabels,
        apiCache
      }) => {
        if (contentLabels) {
          this.filterService.logDdlEvents('Success', 'Content labels retrieved', '');
          return LoadContentLabelsSuccess({
            config,
            contentLabels,
            contentId,
            apiCache,
            actionType
          });
        } else {
          return LoadContentLabelsFailure({
            config,
            contentLabels: {},
            contentId,
            error: 'Failed to retrieve content labels',
            actionType
          });
        }
      }), catchError(error => {
        this.filterService.logDdlEvents('Error', 'Failed to retrieve content labels', error.message);
        return of(LoadContentLabelsFailure({
          config,
          contentLabels: {},
          error: error.message,
          contentId,
          actionType
        }));
      }));
    })));
    this.loadAllFilterGroupSources$ = createEffect(() => this.actions$.pipe(ofType(LoadContentLabelsSuccess, LoadContentLabelsFailure, LoadAllFilterGroupSources), filter(({
      actionType
    }) => this.effectType === actionType), tap(() => this.spinner.show()), concatMap(data => of(data).pipe(withLatestFrom(this.store$.select(getApiCache), this.store$.select(filterListElement(data.contentId)), this.store$.select(getAppliedFilters(data.contentId)), this.store$.select(getAllFilters(data.contentId)), this.store$.select(getOverrideConfig(data.contentId))), switchMap(([{
      config,
      contentLabels,
      contentId,
      actionType
    }, currApiCache, element, appliedFilters, allFilters, overrideConfig]) => {
      const rawFilterGroups = get(config, 'filterGroups', []);
      if (rawFilterGroups.length > 0) {
        this.filterService.logDdlEvents('Success', 'Filter groups found!', '');
        return this.filterService.getFilterGroupSources(contentId, rawFilterGroups, contentLabels, appliedFilters, allFilters, overrideConfig, currApiCache).pipe(map(({
          filterGroups,
          apiCache
        }) => {
          return LoadAllFilterGroupSourcesSuccess({
            config,
            filterGroups,
            contentId,
            apiCache,
            actionType
          });
        }), catchError(error => {
          this.spinner.hide();
          this.filterService.displayErrorMessage(element);
          return of(LoadAllFilterGroupSourcesFailure({
            error: error.message,
            contentId,
            actionType
          }));
        }));
      } else {
        this.filterService.logDdlEvents('Error', 'No filter groups found!', '');
        return of(LoadAllFilterGroupSourcesFailure({
          error: 'No filter groups found!',
          contentId,
          actionType
        }));
      }
    })))));
    this.loadFilterTileData$ = createEffect(() => this.actions$.pipe(ofType(LoadAllFilterGroupSourcesSuccess, LoadFilterTileData), filter(({
      actionType
    }) => this.effectType === actionType), tap(() => this.spinner.show()), concatMap(data => of(data).pipe(withLatestFrom(this.store$.select(getApiCache), this.store$.pipe(select(filterListElement(data.contentId)))), switchMap(([{
      config,
      contentId,
      actionType
    }, currApiCache, element]) => {
      const rawFilterTileData = get(config, 'filterTileData', '');
      const filterTileDataConfig = isArray(rawFilterTileData) ? get(rawFilterTileData, '[0]') : rawFilterTileData;
      const rawFilterGroups = get(config, 'filterGroups', []);
      return this.filterService.getFilterTileData(filterTileDataConfig, rawFilterGroups, currApiCache).pipe(map(({
        filterTiles,
        apiCache
      }) => {
        if (filterTiles) {
          this.filterService.logDdlEvents('Success', 'Retrieved filter tiles', rawFilterTileData);
          return LoadFilterTileDataSuccess({
            contentId,
            filterTileData: filterTiles,
            apiCache,
            actionType
          });
        } else {
          this.spinner.hide();
          this.filterService.displayErrorMessage(element);
          return LoadFilterTileDataFailure({
            contentId,
            error: 'Failed to retrieve filter tiles',
            actionType
          });
        }
      }), catchError(error => {
        this.spinner.hide();
        this.filterService.displayErrorMessage(element);
        this.filterService.logDdlEvents('Error', 'Failed to retrieve filter tiles', error.message);
        return of(LoadFilterTileDataFailure({
          error: error.message,
          contentId,
          actionType
        }));
      }));
    })))));
    this.initQueryParams$ = createEffect(() => this.actions$.pipe(ofType(InitQueryParams), filter(({
      actionType
    }) => this.effectType === actionType), concatMap(data => of(data).pipe(withLatestFrom(this.store$.pipe(select(getAllFilters(data.contentId)))), switchMap(([{
      contentId,
      actionType,
      filtersParamName
    }, allFilters]) => this.filterService.getQueryParams(filtersParamName, allFilters).pipe(map(({
      overrideConfig,
      queryParams
    }) => SetAppliedFilters({
      contentId,
      actionType,
      appliedFilters: queryParams,
      overrideConfig
    }))))))));
    this.SetAppliedFilters$ = createEffect(() => this.actions$.pipe(ofType(SetAppliedFilters), filter(({
      actionType
    }) => this.effectType === actionType), concatMap(data => of(data).pipe(withLatestFrom(this.store$.pipe(select(getFiltersParamName(data.contentId)))), tap(([{
      appliedFilters
    }, filtersParamName]) => {
      this.filterService.setQueryParams(appliedFilters, filtersParamName);
    })))), {
      dispatch: false
    });
    this.SetSelectedFilters$ = createEffect(() => this.actions$.pipe(ofType(SetSelectedFilters), filter(({
      actionType
    }) => this.effectType === actionType)), {
      dispatch: false
    });
    this.filterTiles$ = createEffect(() => this.actions$.pipe(ofType(FilterTiles, SortFilterTiles), filter(({
      actionType
    }) => this.effectType === actionType), concatMap(data => of(data).pipe(withLatestFrom(this.store$.select(getApiCache), this.store$.pipe(select(getFilterTileData(data.contentId))), this.store$.select(getAllFilters(data.contentId)), this.store$.select(getAllLinkedFilters(data.contentId)), this.store$.select(getAppliedFilters(data.contentId))), map(([{
      contentId,
      actionType
    }, cachedData, filterTileData, allFilters, allLinkedFilters, appliedFilters]) => {
      try {
        const filteredTiles = this.filterService.filterTiles(filterTileData, allFilters, allLinkedFilters, appliedFilters, cachedData);
        this.spinner.hide();
        return FilterTilesSuccess({
          contentId,
          filteredTiles,
          actionType
        });
      } catch (error) {
        return FilterTilesFailure({
          error: error.message,
          contentId,
          actionType
        });
      }
    })))));
    this.tileViewChange$ = createEffect(() => this.actions$.pipe(ofType(ChangeFilterTileView), filter(({
      actionType
    }) => this.effectType === actionType), concatMap(data => of(data).pipe(withLatestFrom(this.store$.select(getApiCache), this.store$.pipe(select(getFilterTileConfig(data.contentId))), this.store$.pipe(select(getFilterGroupsConfig(data.contentId)))), switchMap(([{
      contentId,
      view,
      actionType
    }, cachedData, filterTileConfig, filterGroups]) => {
      const filterTileDataConfig = isArray(filterTileConfig) ? get(filterTileConfig, '[0]') : filterTileConfig;
      return this.filterService.getFilterTileData(filterTileDataConfig, filterGroups, cachedData, view).pipe(map(({
        filterTiles
      }) => {
        if (filterTiles) {
          return ChangeFilterTileViewSuccess({
            contentId,
            filterTileData: filterTiles,
            actionType
          });
        } else {
          return ChangeFilterTileViewFailure({
            contentId,
            error: 'Failed to change tile view',
            actionType
          });
        }
      }), catchError(error => {
        this.filterService.logDdlEvents('Error', 'Failed to change tile view', '');
        return of(ChangeFilterTileViewFailure({
          error: error.message,
          contentId,
          actionType
        }));
      }));
    })))));
  }
  static {
    this.ɵfac = function GdsFiltersBaseEffects_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFiltersBaseEffects)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(GdsFiltersBaseService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4$1.SpinnerService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsFiltersBaseEffects,
      factory: GdsFiltersBaseEffects.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFiltersBaseEffects, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: GdsFiltersBaseService
  }, {
    type: i3.Store
  }, {
    type: i4$1.SpinnerService
  }], null);
})();
class GdsInteractiveMapFilterEffects extends GdsFiltersBaseEffects {
  constructor(actions$, filterService, store$, spinner) {
    super(actions$, filterService, store$, spinner);
    this.actions$ = actions$;
    this.filterService = filterService;
    this.store$ = store$;
    this.spinner = spinner;
    this.effectType = GdsFilterActionTypes.INTERACTIVE_MAP;
    this.sortTiles$ = createEffect(() => this.actions$.pipe(ofType(LoadFilterTileDataSuccess, SetSortData), filter$1(({
      actionType
    }) => this.effectType === actionType), concatMap$1(data => of(data).pipe(withLatestFrom$1(this.store$.pipe(select(getFilterTileData(data.contentId)))), map$1(([{
      contentId,
      actionType
    }, filterTileData]) => {
      if (!get(filterTileData, 'results')) return SortFilterTilesEmpty;
      const sortedTiles = this.filterService.sortTiles(filterTileData);
      return SortFilterTiles({
        contentId,
        sortedTiles,
        actionType
      });
    })))));
    this.filterTiles$ = createEffect(() => this.actions$.pipe(ofType(FilterTiles, SortFilterTiles), filter$1(({
      actionType
    }) => this.effectType === actionType), concatMap$1(data => of(data).pipe(withLatestFrom$1(this.store$.select(getApiCache), this.store$.pipe(select(getFilterTileData(data.contentId))), this.store$.select(getAllFilters(data.contentId)), this.store$.select(getAllLinkedFilters(data.contentId)), this.store$.select(getAppliedFilters(data.contentId))), map$1(([{
      contentId,
      actionType
    }, cachedData, filterTileData, allFilters, allLinkedFilters, appliedFilters]) => {
      try {
        const filteredTiles = this.filterService.filterTiles(filterTileData, allFilters, allLinkedFilters, appliedFilters, cachedData);
        this.spinner.hide();
        return FilterTilesSuccess({
          contentId,
          filteredTiles,
          actionType
        });
      } catch (error) {
        return FilterTilesFailure({
          error: error.message,
          contentId,
          actionType
        });
      }
    })))));
  }
  static {
    this.ɵfac = function GdsInteractiveMapFilterEffects_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInteractiveMapFilterEffects)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(GdsInteractiveMapFilterService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4$1.SpinnerService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsInteractiveMapFilterEffects,
      factory: GdsInteractiveMapFilterEffects.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInteractiveMapFilterEffects, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: GdsInteractiveMapFilterService
  }, {
    type: i3.Store
  }, {
    type: i4$1.SpinnerService
  }], null);
})();
class GdsFilterListEffects extends GdsFiltersBaseEffects {
  constructor(actions$, filterService, store$, spinner) {
    super(actions$, filterService, store$, spinner);
    this.actions$ = actions$;
    this.filterService = filterService;
    this.store$ = store$;
    this.spinner = spinner;
    this.effectType = GdsFilterActionTypes.FILTER_LIST;
    this.sortTiles$ = createEffect(() => this.actions$.pipe(ofType(ChangeFilterTileViewSuccess, LoadFilterTileDataSuccess, SetSortData), filter$1(({
      actionType
    }) => this.effectType === actionType), switchMap$1(data => of(data).pipe(withLatestFrom$1(this.store$.select(getApiCache), this.store$.pipe(select(getFilterTileData(data.contentId)))), map$1(([{
      contentId,
      actionType
    }, cachedData, filterTileData]) => {
      if (!get(filterTileData, 'results')) return SortFilterTilesEmpty();
      const sortedTiles = this.filterService.sortTiles(filterTileData, cachedData);
      return SortFilterTiles({
        contentId,
        sortedTiles,
        actionType
      });
    })))));
  }
  static {
    this.ɵfac = function GdsFilterListEffects_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFilterListEffects)(i0.ɵɵinject(i1$1.Actions), i0.ɵɵinject(GdsFilterListService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4$1.SpinnerService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsFilterListEffects,
      factory: GdsFilterListEffects.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFilterListEffects, [{
    type: Injectable
  }], () => [{
    type: i1$1.Actions
  }, {
    type: GdsFilterListService
  }, {
    type: i3.Store
  }, {
    type: i4$1.SpinnerService
  }], null);
})();
class GdsFilterListModule {
  static {
    this.ɵfac = function GdsFilterListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFilterListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsFilterListModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsFilterListService, GdsInteractiveMapFilterService],
      imports: [StoreModule.forFeature(filtersFeatureKey, reducers), EffectsModule.forFeature([GdsInteractiveMapFilterEffects, GdsFilterListEffects])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFilterListModule, [{
    type: NgModule,
    args: [{
      providers: [GdsFilterListService, GdsInteractiveMapFilterService],
      imports: [StoreModule.forFeature(filtersFeatureKey, reducers), EffectsModule.forFeature([GdsInteractiveMapFilterEffects, GdsFilterListEffects])]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-filter-list
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsFilterListModule, GdsFilterListService, GdsInteractiveMapFilterService, filtersFeatureKey };
